import { Col, Form, Row } from "react-bootstrap";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import {
  Box,
  Button,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import ExcelIcon from "../../assets/images/ExcelExport.png";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useLoader } from "../../context/LoaderContext";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-enterprise";
import { PreworkSummaryListDetailsViewModel } from "../../types/PreworkSummaryListDetailsViewModel";
import {
  AcceptPreworkDetails,
  GetDownloadFiles,
  GetPreWorkDetails,
} from "../../api/preworkDetailApi/preworkDetailApi";
import NoteIcon from "@mui/icons-material/Summarize";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InfoIcon from "@mui/icons-material/Info";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import InfoDrawer from "../SimpleSearch/InfoDrawer";
import { PreworkDetailDownloadFileModel } from "../../types/PreworkDetailDownloadFileModel";
import Notes from "../Alert/Notes";
import FileUploads from "../Alert/FileUploads";
import AddNotes from "../Alert/AddNotes";
import RenamePopup from "../Alert/Rename";
import RejectFile from "../Alert/RejectFile";
import ConfirmationAlert from "../Alert/ConfirmationAlert";
import { PreworkDetailViewModel } from "../../types/PreworkDetailsViewModel";
import { PreworkSummaryListDetails } from "../../types/PreworkSummaryListDetailsModel";
import { PreworkSummaryListDetailchildModel } from "../../types/PreworkSummaryListDetailchildModel";
import { forEach } from "lodash";
import MoveToPreflightPopup from "../Alert/MoveToPreflightPopup";
import MoveToFinal from "../Alert/MoveToFinal";
import ReprocessSendToPreflight from "../Alert/ReprocessSendToPreflight";
import { useNavigate } from "react-router-dom";
import DocviewPopup from "../Alert/DocviewPopup";
import { useSnackbar } from "../Common/SnackbarContext";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { urlConfig } from "../../config/urlConfig";
import { appSettings } from "../../config/appSetting";
import { FormatDate } from "../Common/CommonMethods";
import CustomLoadingOverlay from "../CustomLoadingOverlay/CustomLoadingOverlay ";
import isPagePermission from "../../utils/common";
import LocalStorageUtil from "../../utils/localStorage";
import moment from "moment";
import * as XLSX from "xlsx";

const PreworkDetail: React.FC = () => {
  const [showLoader, setShowLoader] = useState(false);
  const { showSnackbar } = useSnackbar();
  const { setLoading } = useLoader();
  const [gridRecordExist, setGridRecordExist] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [validationMessage, setValidationMessage] = useState<string | null>(
    null
  );
  const pageSizeSelector = appSettings.agGridPageSizeSelector;
  const defaultPageSize = appSettings.agGridDefaulPageSize;
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);
  const [childColumnDefs, setChildColumnDefs] = useState<ColDef[]>([]);
  const [rowData, setRowData] = useState<PreworkSummaryListDetailsViewModel[]>(
    []
  );
  const gridRef = useRef<AgGridReact>(null);
  const [activeButton, setActiveButton] = useState<string>("");
  const [fromSourceCount, setFromSourceCount] = useState<number>(0);
  const [inProcessCount, setInProcessCount] = useState<number>(0);
  const [finalCount, setFinalCount] = useState<number>(0);
  const [allCount, setAllCount] = useState<number>(0);
  const [searchContent, setsearchContent] = useState<string>("");
  const [showIconButton, setShowIconButton] = useState<boolean>(false);
  const [tabType, setTabType] = useState<number>(1);
  const [inProgressTabType, setInProgressTabType] = useState<number>(2);
  const [activeButtonInProgress, setActiveButtonInProgress] =
    useState<string>("");
  const [selectedDocument, setSelectedDocument] = useState<any>(null);
  const [notesOpen, setNotesOpen] = useState(false);
  const [notesData, setNotesData] = useState<any>(null);
  const [type, setType] = useState<string>("parent");
  const [drawerOpen, setDrawerOpen] = useState(false);
  let isNotesExportStatusHide = true;
  let isExportStatusHide = true;
  let isStatusHide = true;
  let isParentStatusHide = true;
  const [uploadFilesOpen, setUploadFilesOpen] = useState(false);
  const [uploadFilesData, setUploadFilesData] = useState<any>(null);
  const [addNotesOpen, setAddNotesOpen] = useState(false);
  const [addNotesData, setAddNotesData] = useState(false);
  const [renamePopupOpen, setRenamePopupOpen] = useState(false);
  const [renameData, setRenameData] = useState<any>(null);
  const [rejectPopupOpen, setRejectPopupOpen] = useState(false);
  const [rejectData, setRejectData] = useState<any>(null);
  const [deleteConfirmationDialogOpen, setdeleteConfirmationDialogOpen] =
    useState(false);
  const [deleteDocumentData, setDeleteDocumentData] = useState<any>(null);
  const [validateAccept, setValidateAccept] = useState<string | null>(null);
  const [moveToPreflightOpen, setMoveToPreflightOpen] = useState(false);
  const [moveToPreflightData, setMoveToPreflightData] = useState<any>(null);
  const [moveToFinalFolderOpen, setMoveToFinalFolderOpen] = useState(false);
  const [moveToFinalFolderData, setMoveToFinalFolderData] = useState<any>(null);
  const [contextMenuType, setContextMenuType] = useState<number>(1);
  const [moveToFinalPopupTitle, setMoveToFinalPopupTitle] =
    useState<string>("");
  const [reprocessSendToPreflightOpen, setReprocessSendToPreflightOpen] =
    useState(false);
  const [reprocessSendToPreflightData, setReprocessSendToPreflightData] =
    useState<any>(null);
  const [docViewOpen, setDocViewOpen] = useState(false);
  const [docViewData, setDocViewData] = useState<any>(null);
  let tabValue = 1;
  let tabValueInProgress = 2;
  const navigate = useNavigate();
  const [documentStatusValue, setDocumentStatus] = useState<number>(0); //NOSONAR

  useEffect(() => {
    try {
      const params = {
        Accountid: Number(LocalStorageUtil.getItem("accountId")) || 0,
        Datebasedocid: 1,
        Documentstatus: 1,
        IsConsolatedView: false,
        Timezone: appSettings.timezone,
        Userid: Number(LocalStorageUtil.getItem("userId")) || 0,
        contextName: LocalStorageUtil.getItem("contextName") ?? "",
        currentPage: 0,
        documentStatusIds:
          "2,6,20,23,24,11,27,1,3,21,33,34,35,25,26,18,28,17,30,31,32",
        isexporttpExcel: false,
        noOfRecords: 0,
        pagename: "PreWorkDetails",
        sortOrder: 1,
      };
      fetchData(params);
      setActiveButton("FROM SOURCE");
    } catch (error) {}
  }, []);

  // Handel search text change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 0) {
      setShowIconButton(true);
      setsearchContent(e.target.value);
    } else {
      setShowIconButton(false);
      setsearchContent("");
    }
  };

  // Search content on enter key press
  const handleSearchKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearchSubmit();
    }
  };

  // Handel search button click
  const handleSearchSubmit = () => {
    try {
      if (searchContent.trim().length > 0) {
        tabMenu(
          tabType === 2 ? inProgressTabType : tabType,
          null,
          null,
          searchContent
        );
      } else {
        showSnackbar("Please enter search content", true);
      }
    } catch (error) {}
  };

  // Handel search content clear
  const handelSearchContentClear = () => {
    try {
      setsearchContent("");
      setShowIconButton(false);
      tabMenu(tabType === 2 ? inProgressTabType : tabType, null, null);
    } catch (error) {}
  };

  //Handle Export to excel
  const handleExport = async () => {
    try {
      setLoading(true);

      if (!gridRef.current || rowData.length === 0) {
        showSnackbar("No data available to export", true);
        return;
      }

      // Prepare data for export
      const exportData: any[] = [];

      // Process each parent row and its children
      rowData.forEach((parentRow: any) => {
        // Add parent row data
        const parentExportRow = {
          //Type: "Parent",
          "File Name": parentRow.Filename || "",
          "Display Name": parentRow.parentDocumentDescription || "",
          "Document ID": parentRow.finalDocID || "",
          "Project ID": parentRow["Project ID"] || "",
          "Work Area": parentRow["Work Area"] || "",
          "Uploaded On": parentRow.Uploadedon
            ? FormatDate(parentRow.Uploadedon)
            : "",
          "Uploaded By": parentRow.UploadBy || "",
          "Accepted On": parentRow.AcceptedOn
            ? FormatDate(parentRow.AcceptedOn)
            : "",
          "Accepted By": parentRow.AcceptedBy || "",
        };

        exportData.push(parentExportRow);

        // Add child rows if they exist
        if (parentRow.ChildList && parentRow.ChildList.length > 0) {
          parentRow.ChildList.forEach((childRow: any) => {
            const childExportRow = {
              //Type: "Child",
              "File Name": childRow.Filename || "",
              "Display Name": childRow["Display Name"] || "",
              "Document ID": childRow.finalDocID || "",
              "Project ID": childRow["Project ID"] || "",
              "Work Area": childRow["Work Area"] || "",
              "Uploaded On": childRow.Uploadedon
                ? FormatDate(childRow.Uploadedon)
                : "",
              "Uploaded By": childRow.UploadBy || "",
              "Accepted On": childRow.AcceptedOn
                ? FormatDate(childRow.AcceptedOn)
                : "",
              "Accepted By": childRow.AcceptedBy || "",
            };

            exportData.push(childExportRow);
          });
        }

        // Add empty row for separation
        exportData.push({});
      });

      // Create CSV content
      if (exportData.length === 0) {
        showSnackbar("No data to export", true);
        return;
      }

      // Filter out empty rows for Excel export
      const cleanedExportData = exportData.filter(
        (row) => Object.keys(row).length > 0
      );

      // Create a new workbook
      const workbook = XLSX.utils.book_new();

      // Convert data to worksheet
      const worksheet = XLSX.utils.json_to_sheet(cleanedExportData);

      // Set column widths for better readability
      const columnWidths = [
        { wch: 30 }, // File Name
        { wch: 25 }, // Display Name
        { wch: 15 }, // Document ID
        { wch: 15 }, // Project ID
        { wch: 20 }, // Work Area
        { wch: 20 }, // Uploaded On
        { wch: 20 }, // Uploaded By
        { wch: 20 }, // Accepted On
        { wch: 20 }, // Accepted By
      ];

      worksheet["!cols"] = columnWidths;

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Prework Details");

      // Generate Excel file
      const filename = "PreworkDetailReports";
      const today = new Date().toISOString().split("T")[0];
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      // Create blob and download
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const linkElement = document.createElement("a");

      linkElement.setAttribute("href", url);
      linkElement.setAttribute("download", `${filename}_${today}.xlsx`);
      linkElement.style.display = "none";
      document.body.appendChild(linkElement);
      linkElement.click();
      document.body.removeChild(linkElement);

      // Clean up the URL object
      window.URL.revokeObjectURL(url);
      showSnackbar("Excel export completed successfully");
    } catch (error) {
      console.error("Error exporting data:", error);
      showSnackbar("Error occurred while exporting data", true);
    } finally {
      setLoading(false);
    }
  };

  // Apply button click event
  const handleApplyButton = () => {
    try {
      if (startDate === null) {
        setValidationMessage("Please select From date");
        return;
      } else if (endDate === null) {
        setValidationMessage("Please select To date");
        return;
      } else if (startDate && endDate) {
        if (startDate > endDate) {
          setValidationMessage("To date should be greater than From date");
          return;
        } else {
          setValidationMessage("");
          tabMenu(tabType, startDate, endDate);
        }
      }
    } catch (error) {}
  };

  //handel reset button
  const handleReset = () => {
    try {
      tabMenu(tabType, null, null);
      setStartDate(null);
      setEndDate(null);
    } catch (error) {}
  };

  // From Source tab click event
  const handleFromSourceTabClick = (tabType: number, buttonName: string) => {
    try {
      tabValue = tabType;
      isNotesExportStatusHide = true;
      isExportStatusHide = true;
      isStatusHide = true;
      isParentStatusHide = true;
      setActiveButton(buttonName);
      setTabType(tabType);
      setInProgressTabType(20);
      tabValueInProgress = 20;
      setDocumentStatus(tabType);
      tabMenu(tabType, null, null);
    } catch (error) {}
  };

  // handel In-Process tab click event
  const handleInProcessTabClick = (tabType: number, buttonName: string) => {
    try {
      tabValue = tabType;
      isNotesExportStatusHide = false;
      isExportStatusHide = true;
      isStatusHide = true;
      isParentStatusHide = true;
      setActiveButton(buttonName);
      setTabType(tabType);
      setInProgressTabType(20);
      tabValueInProgress = 20;
      setDocumentStatus(tabType);
      setRowData([]);
      handleStagingInProcessTabClick(2, "STAGING");
    } catch (error) {}
  };

  // Final tab click event
  const handleFinalTabClick = (tabType: number, buttonName: string) => {
    try {
      tabValue = tabType;
      isNotesExportStatusHide = false;
      isExportStatusHide = false;
      isStatusHide = true;
      isParentStatusHide = true;
      setActiveButton(buttonName);
      setTabType(tabType);
      setInProgressTabType(20);
      tabValueInProgress = 20;
      setDocumentStatus(tabType);
      tabMenu(tabType, null, null);
    } catch {}
  };

  // All tab click event
  const handleAllTabClick = (tabType: number, buttonName: string) => {
    try {
      tabValue = tabType;
      isNotesExportStatusHide = false;
      isExportStatusHide = true;
      isStatusHide = false;
      isParentStatusHide = false;
      setActiveButton(buttonName);
      setTabType(tabType);
      setInProgressTabType(20);
      tabValueInProgress = 20;
      setDocumentStatus(tabType);
      tabMenu(tabType, null, null);
    } catch (error) {}
  };

  // Staging In Process tab click event
  const handleStagingInProcessTabClick = (
    tabType: number,
    buttonName: string
  ) => {
    try {
      tabValue = 2;
      isNotesExportStatusHide = false;
      isExportStatusHide = true;
      isStatusHide = false;
      isParentStatusHide = true;
      setActiveButton("IN-PROGRESS");
      setActiveButtonInProgress(buttonName);
      setTabType(2);
      setInProgressTabType(tabType);
      tabValueInProgress = tabType;
      setDocumentStatus(tabType);
      tabMenu(tabType, null, null);
    } catch (error) {}
  };

  // To Preflight In Progress tab click event
  const handelToPreflightInProgressTabClick = (
    tabType: number,
    buttonName: string
  ) => {
    try {
      tabValue = 2;
      isNotesExportStatusHide = false;
      isExportStatusHide = false;
      isStatusHide = true;
      isParentStatusHide = true;
      setActiveButton("IN-PROGRESS");
      setActiveButtonInProgress(buttonName);
      setTabType(2);
      setInProgressTabType(tabType);
      tabValueInProgress = tabType;
      tabMenu(tabType, null, null);
      setDocumentStatus(tabType);
    } catch (error) {}
  };

  // From Preflight In Progress tab click event
  const handelFromPreflightInProgressTabClick = (
    tabType: number,
    buttonName: string
  ) => {
    try {
      tabValue = 2;
      isNotesExportStatusHide = false;
      isExportStatusHide = false;
      isStatusHide = true;
      isParentStatusHide = true;
      setActiveButton("IN-PROGRESS");
      setActiveButtonInProgress(buttonName);
      setTabType(2);
      setInProgressTabType(tabType);
      tabValueInProgress = tabType;
      setDocumentStatus(tabType);
      tabMenu(tabType, null, null);
    } catch (error) {}
  };

  // To VIS In Progress tab click event
  const handelToVISInProgressTabClick = (
    tabType: number,
    buttonName: string
  ) => {
    try {
      tabValue = 2;
      isNotesExportStatusHide = false;
      isExportStatusHide = false;
      isStatusHide = true;
      isParentStatusHide = true;
      setActiveButton("IN-PROGRESS");
      setActiveButtonInProgress(buttonName);
      setTabType(2);
      setInProgressTabType(tabType);
      tabValueInProgress = tabType;
      setDocumentStatus(tabType);
      tabMenu(tabType, null, null);
    } catch (error) {}
  };

  // From VIS In Progress tab click event
  const handelFromVISInProgressTabClick = (
    tabType: number,
    buttonName: string
  ) => {
    try {
      tabValue = 2;
      isNotesExportStatusHide = false;
      isExportStatusHide = false;
      isStatusHide = true;
      isParentStatusHide = true;
      setActiveButton("IN-PROGRESS");
      setActiveButtonInProgress(buttonName);
      setTabType(2);
      setInProgressTabType(tabType);
      tabValueInProgress = tabType;
      setDocumentStatus(tabType);
      tabMenu(tabType, null, null);
    } catch (error) {}
  };

  // tab menu click event
  const tabMenu = (
    tabTypeVal: number,
    fromDate: Date | null | undefined,
    toDate: Date | null | undefined,
    searchText: string = ""
  ) => {
    try {
      const params = {
        Accountid: Number(LocalStorageUtil.getItem("accountId")) || 0,
        Datebasedocid: tabTypeVal,
        Documentstatus: tabTypeVal,
        IsConsolatedView: false,
        Timezone: appSettings.timezone,
        Userid: Number(LocalStorageUtil.getItem("userId")) || 0,
        contextName: LocalStorageUtil.getItem("contextName") ?? "",
        currentPage: 0,
        documentStatusIds:
          "2,6,20,23,24,11,27,1,3,21,33,34,35,25,26,18,28,17,30,31,32",
        isexporttpExcel: false,
        noOfRecords: 0,
        pagename: "PreWorkDetails",
        sortOrder: 1,
        Search: searchText,
      };
      fetchData(params);
    } catch (error) {}
  };

  // Helper function to create date column definition
  const createDateColumn = (
    key: string,
    params: any,
    hideCondition: boolean = false
  ) => {
    return {
      headerName: renameColumns(key.charAt(0).toUpperCase() + key.slice(1)),
      field: key,
      sortable: true,
      filter: true,
      enableRowGroup: true,
      valueFormatter: (params: any) => FormatDate(params.value),
      hide: hideCondition,
    };
  };

  // Helper function to create standard column definition
  const createStandardColumn = (
    key: string,
    hideCondition: boolean = false
  ) => {
    return {
      headerName: renameColumns(key.charAt(0).toUpperCase() + key.slice(1)),
      field: key,
      sortable: true,
      filter: true,
      enableRowGroup: true,
      width: 200,
      hide: hideCondition,
    };
  };

  // Helper function to get export status renderer
  const getExportStatusRenderer = (status: number) => {
    const statusMap: Record<
      number,
      { title: string; className: string; text: string }
    > = {
      20: { title: "MPF Inprogress", className: "yellow_circle", text: "N" },
      6: { title: "Export to MPF", className: "green_circle", text: "Y" },
      23: { title: "MPF Failed", className: "red_circle", text: "F" },
      24: { title: "MPF Failed", className: "red_circle", text: "F" },
      33: {
        title: "Trigger Prod WF Inprogress",
        className: "yellow_circle",
        text: "N",
      },
      21: { title: "Final Inprogress", className: "yellow_circle", text: "N" },
      3: {
        title: "Move To Final Success",
        className: "green_circle",
        text: "Y",
      },
      25: { title: "MoveFinal Failed", className: "red_circle", text: "F" },
      26: { title: "MoveFinal Failed", className: "red_circle", text: "F" },
      34: { title: "MoveFinal Failed", className: "red_circle", text: "F" },
      35: { title: "MoveFinal Failed", className: "red_circle", text: "F" },
      11: {
        title: "From Preflight Success",
        className: "green_circle",
        text: "Y",
      },
      27: {
        title: "From Preflight Failed",
        className: "red_circle",
        text: "F",
      },
      17: {
        title: "Trigger Proof WF Success",
        className: "green_circle",
        text: "Y",
      },
      30: {
        title: "Trigger Proof WF In Progress",
        className: "yellow_circle",
        text: "N",
      },
      31: {
        title: "Trigger Proof WF Failed",
        className: "red_circle",
        text: "F",
      },
      32: {
        title: "Trigger Proof WF Failed",
        className: "red_circle",
        text: "F",
      },
      18: { title: "From VIS Success", className: "green_circle", text: "Y" },
      28: { title: "From VIS Failed", className: "red_circle", text: "F" },
    };

    const statusInfo = statusMap[status];
    if (!statusInfo) return "NA";

    return (
      <span title={statusInfo.title} className={statusInfo.className}>
        {statusInfo.text}
      </span>
    );
  };

  // Helper function to render export status cell
  const renderExportStatusCell = (params: any) => {
    if (!params.data.parentDocumenStatusName) return "NA";
    return getExportStatusRenderer(params.data.parentDocumentStatus);
  };

  // Helper function to render notes cell
  const renderNotesCell = (
    params: any,
    viewNotesHandler: (params: any) => void
  ) => {
    return params.data.isDoccount > 0 ? (
      <Tooltip title="Click to view the notes">
        <IconButton
          style={{ color: "var(--aggrid-text-color)" }}
          onClick={() => viewNotesHandler(params)}
        >
          <NoteIcon />
        </IconButton>
      </Tooltip>
    ) : (
      "NA"
    );
  };

  // Helper function to build dynamic columns
  const buildDynamicColumns = (
    data: any,
    params: any,
    columnsToExclude: string[]
  ) => {
    return Object.keys(data)
      .filter((key) => !columnsToExclude.includes(key))
      .map((key: string) => {
        const lowerKey = key.toLowerCase();

        if (lowerKey.includes("acceptedon") || lowerKey.includes("date")) {
          return createDateColumn(key, params, params.DocumentStatus === 1);
        }

        if (lowerKey.includes("uploadedon")) {
          return createDateColumn(key, params, false);
        }

        if (lowerKey.includes("acceptedby")) {
          return createStandardColumn(key, params.DocumentStatus === 1);
        }

        return createStandardColumn(key, false);
      });
  };

  // Fetch data from API and set Parent and child grid data with their column definitions
  const fetchData = async (params: any) => {
    try {
      setShowLoader(true);
      const response = await GetPreWorkDetails(params);

      if (!response || response.length === 0) {
        setColumnDefs([]);
        setRowData([]);
        setGridRecordExist(false);
        return;
      }

      tabValue = params.QueueType;

      if (response[0].ParentList[0].RowNum === 0) {
        updateCounters(response[0].ParentList[0]);
        setRowData([]);
        setGridRecordExist(false);
        setLoading(false);
        return;
      }

      setGridRecordExist(true);

      // Process parent and child lists
      const mappedParentList = processParentList(response, params);
      const filteredParentList = filterParentList(mappedParentList);

      setRowData(filteredParentList);
      updateCounters(response[0].ParentList[0]);

      // Build column definitions
      const dynamicColumns = buildDynamicColumns(
        response[0].ParentList[0],
        params,
        columnsToExclude
      );

      const combinedColumnDefs = [
        ...getStaticColumns(),
        ...dynamicColumns,
        getNotesColumn(),
        getExportStatusColumn(),
        getStatusColumn(),
        getActionsColumn(),
      ];

      setColumnDefs(combinedColumnDefs);

      // Build child column definitions if needed
      if (response[0].ChildList?.length > 0) {
        buildChildColumnDefs(response[0].ChildList[0], params);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setShowLoader(false);
    }
  };

  // Helper function to update counters
  const updateCounters = (parentList: any) => {
    setFromSourceCount(parentList.newCounts);
    setInProcessCount(
      parentList.inprogressCounts +
        parentList.topreflight +
        parentList.fromPreflight +
        parentList.tovsiCounts +
        parentList.fromVsiCounts
    );
    setFinalCount(parentList.completedCounts);
    setAllCount(parentList.allCounts);
  };

  // Helper function to process parent list
  const processParentList = (response: any[], params: any) => {
    return response
      .map((item: any) => {
        if (params.Documentstatus === 2 && item.ChildList === null) {
          return item.ParentList;
        }

        if (
          (params.Documentstatus === 1 ||
            params.Documentstatus === 2 ||
            params.Documentstatus === 0) &&
          item.ChildList &&
          item.ChildList.length > 0
        ) {
          // Special handling for Staging tab to promote Excel files to parent level
          const result: any[] = [];

          // Group children by ParentID
          const childrenByParent: { [key: string]: any[] } = {};
          item.ChildList.forEach((child: any) => {
            const parentId = child.ParentID;
            if (!childrenByParent[parentId]) {
              childrenByParent[parentId] = [];
            }
            childrenByParent[parentId].push(child);
          });

          // Process each parent
          item.ParentList.forEach((parent: any) => {
            const children = childrenByParent[parent.ID] || [];

            // Find Excel files
            const excelFiles = children.filter((child: any) => {
              const fileType = child.childFileType?.toLowerCase();
              return fileType === ".xls" || fileType === ".xlsx";
            });

            // Find non-Excel files
            const nonExcelFiles = children.filter((child: any) => {
              const fileType = child.childFileType?.toLowerCase();
              return fileType !== ".xls" && fileType !== ".xlsx";
            });

            if (excelFiles.length > 0) {
              // Use Excel file data for parent display
              const excelFile = excelFiles[0];
              const enhancedParent = {
                ...parent,
                // Override parent data with Excel file data for proper binding
                Filename: excelFile.Filename,
                childFileDocumentStreamID: excelFile.childFileDocumentStreamID,
                DocumentStreamId: excelFile.childFileDocumentStreamID, // Add this for AG Grid binding
                childFileType: excelFile.childFileType,
                childDocumentID: excelFile.childDocumentID,
                childAcceptedId: excelFile.childAcceptedId,
                parentDocumentStatus:
                  parent.parentDocumentStatus || excelFile.childDocumentStatus,
                // Map additional required fields
                Uploadedon: excelFile.childFileUploadedon || parent.Uploadedon,
                UploadBy: excelFile.childUploadBy || parent.UploadBy,
                // Keep remaining files as children
                ChildList: [...nonExcelFiles, ...excelFiles.slice(1)],
              };
              result.push(enhancedParent);
            } else if (nonExcelFiles.length > 0) {
              // If no Excel files, use first file as parent
              const firstFile = nonExcelFiles[0];
              const enhancedParent = {
                ...parent,
                Filename: firstFile.Filename,
                childFileDocumentStreamID: firstFile.childFileDocumentStreamID,
                DocumentStreamId: firstFile.childFileDocumentStreamID, // Add this for AG Grid binding
                childFileType: firstFile.childFileType,
                childDocumentID: firstFile.childDocumentID,
                childAcceptedId: firstFile.childAcceptedId,
                parentDocumentStatus:
                  parent.parentDocumentStatus || firstFile.childDocumentStatus,
                Uploadedon: firstFile.childFileUploadedon || parent.Uploadedon,
                UploadBy: firstFile.childUploadBy || parent.UploadBy,
                ChildList: nonExcelFiles.slice(1),
              };
              result.push(enhancedParent);
            } else {
              // No children, keep parent as is but ensure DocumentStreamId is mapped
              result.push({
                ...parent,
                DocumentStreamId:
                  parent.parentDocumentStreamID || parent.DocumentStreamId,
                ChildList: [],
              });
            }
          });

          return result;
        }

        if (
          params.Documentstatus !== 2 &&
          (!item.ChildList || item.ChildList.length <= 1)
        ) {
          return item.ParentList;
        }
        return item.ParentList.map((parent: any) => {
          parent.ChildList = item.ChildList.filter(
            (child: any) =>
              child.ParentID === parent.ID &&
              child.childFileType.toLowerCase() === ".pdf"
          );
          return parent;
        });
      })
      .flat();
  };

  // Helper function to filter parent list
  const filterParentList = (mappedParentList: any[]) => {
    return mappedParentList.map((item: any) => {
      if (!item.ChildList || item.ChildList.length === 0) return item;

      const parentFileName = item.Filename?.toLowerCase();
      const parentUploadedOn = new Date(item.Uploadedon).getTime();

      const filteredChilds = item.ChildList.filter((child: any) => {
        const childFileName = child.Filename?.toLowerCase();
        const childUploadedOn = new Date(child.Uploadedon).getTime();
        const isSame =
          childFileName === parentFileName &&
          childUploadedOn === parentUploadedOn;
        return !isSame;
      });

      return { ...item, ChildList: filteredChilds };
    });
  };

  // Helper function to get static columns
  const getStaticColumns = () => [
    {
      width: 50,
      sortable: false,
      filter: false,
      hide: false,
      colId: "colCheckbox",
      suppressSizeToFit: true,
      enableRowGroup: false,
      resizable: false,
      pinned: "left" as const,
      lockPinned: true,
    },
    {
      headerName: "#",
      width: 100,
      suppressSizeToFit: true,
      colId: "colRowNum",
      sortable: false,
      filter: false,
      resizable: false,
      enableRowGroup: false,
      cellRenderer: "agGroupCellRenderer",
      pinned: "left" as const,
      lockPinned: true,
      valueGetter: (params: any) =>
        params.node ? (params.node.rowIndex ?? 0) + 1 : 0,
    },
  ];

  // Helper function to get notes column
  const getNotesColumn = () => ({
    headerName: "Notes",
    field: "isDocCount",
    sortable: false,
    filter: false,
    enableRowGroup: false,
    width: 120,
    hide: isNotesExportStatusHide,
    cellRenderer: (params: any) => renderNotesCell(params, viewParentNotes),
    cellStyle: { textAlign: "center" },
  });

  // Helper function to get export status column
  const getExportStatusColumn = () => ({
    headerName: "Export Status",
    sortable: false,
    filter: false,
    enableRowGroup: false,
    width: 150,
    hide: isExportStatusHide,
    cellRenderer: renderExportStatusCell,
  });

  // Helper function to get status column
  const getStatusColumn = () => ({
    headerName: "Status",
    field: "parentDocumenStatusName",
    sortable: false,
    filter: false,
    enableRowGroup: false,
    width: 120,
    hide: isParentStatusHide,
  });

  // Helper function to get actions column
  const getActionsColumn = () => ({
    field: "Actions",
    headerName: "Actions",
    sortable: false,
    enableRowGroup: false,
    pinned: "right" as const,
    lockPinned: true,
    suppressSizeToFit: true,
    width: 120,
    minWidth: 120,
    cellClass: "actions-button-cell",
    cellRenderer: ActionParentCellRenderer,
    filter: false,
    resizable: false,
    colId: "colAction",
  });

  // Helper function to build child column definitions
  const buildChildColumnDefs = (childData: any, params: any) => {
    const dynamicChildColumns = buildDynamicColumns(
      childData,
      params,
      columnsToExclude
    );

    const combinedChildColumnDefs = [
      {
        headerName: "#",
        width: 30,
        suppressSizeToFit: true,
        colId: "colRowNum",
        sortable: false,
        filter: false,
        resizable: false,
        enableRowGroup: false,
        pinned: "left" as const,
        lockPinned: true,
        valueGetter: (params: any) =>
          params.node ? (params.node.rowIndex ?? 0) + 1 : 0,
      },
      {
        checkboxSelection: true,
        headerCheckboxSelection: true,
        width: 30,
        sortable: false,
        filter: false,
        hide: false,
        colId: "colCheckbox",
        suppressSizeToFit: true,
        enableRowGroup: false,
        resizable: false,
        pinned: "left" as const,
        lockPinned: true,
      },
      ...dynamicChildColumns,
      {
        headerName: "Notes",
        field: "isDocCount",
        sortable: false,
        filter: false,
        enableRowGroup: false,
        width: 120,
        hide: isNotesExportStatusHide,
        cellRenderer: (params: any) => renderNotesCell(params, viewChildNotes),
        cellStyle: { justifyContent: "center" },
      },
      {
        headerName: "Status",
        field: "childDocumenStatusName",
        sortable: false,
        filter: false,
        enableRowGroup: false,
        width: 120,
        hide: isStatusHide,
      },
      {
        field: "Actions",
        headerName: "Actions",
        sortable: false,
        enableRowGroup: false,
        pinned: "right" as const,
        lockPinned: true,
        suppressSizeToFit: true,
        width: 130,
        minWidth: 130,
        cellClass: "actions-button-cell",
        cellRenderer: ActionChildCellRenderer,
        filter: false,
        resizable: false,
        colId: "colAction",
      },
    ];

    setChildColumnDefs(combinedChildColumnDefs);
  };

  //Action child cell renderer
  const ActionChildCellRenderer = (params: any) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const handleChildClick = (event: any) => {
      event.stopPropagation(); // Prevent row deselection
      event.preventDefault(); // Prevent default behavior
      setAnchorEl(event.currentTarget);
    };

    const handleChildClose = (actionType: number, rowData: any) => {
      try {
        if (actionType === 0) {
          //Upload
          handelUploadFiles(rowData, 1);
        } else if (actionType === 1) {
          //Add Notes
          handleAddNotes(rowData);
        } else if (actionType === 2) {
          //Rename
          handleRename(rowData);
        } else if (actionType === 3) {
          //Reject
          handleReject(rowData);
        } else if (actionType === 4) {
          //Delete
          handleDelete(rowData, 1);
        } else if (actionType === 5) {
          //Reprocess - Send to Preflight
          reprocessSendToPreflight(rowData);
        } else if (actionType === 6) {
          //Move to Preflight
          moveToPreflight(rowData, 0);
        }
      } catch (error) {
      } finally {
        setAnchorEl(null);
      }
    };
    const rowData = params.data;
    if (params.data === undefined) {
      return "";
    } else {
      return (
        <div>
          {isPagePermission("Allow Download", "PreworkDetail", 154) && (
            <Tooltip title="Click here to download the documents">
              <IconButton
                style={{ padding: "2px", color: "var(--aggrid-text-color)" }}
                onClick={() => fileDownloadParent(rowData)}
              >
                <FileDownloadIcon className="icon-button-other" />
              </IconButton>
            </Tooltip>
          )}
          {isPagePermission("Allow DocumentPreView", "PreworkDetail", 165) && (
            <Tooltip title="Click to view">
              <IconButton
                style={{ padding: "2px", color: "var(--aggrid-text-color)" }}
                onClick={() => viewDocumentParent(rowData)}
              >
                <VisibilityIcon className="icon-button-other" />
              </IconButton>
            </Tooltip>
          )}
          {isPagePermission(
            "Allow Metadata Information",
            "PreworkDetail",
            166
          ) && (
            <Tooltip title="Click to view the file information and history">
              <IconButton
                style={{ padding: "2px", color: "var(--aggrid-text-color)" }}
                onClick={() => infoDocument(rowData)}
              >
                <InfoIcon className="icon-button-other" />
              </IconButton>
            </Tooltip>
          )}
          <>
            <MoreVertIcon
              className="editIcon"
              onClick={handleChildClick}
              style={{
                padding: "0.2vh",
                color: "var(--aggrid-text-color)",
                cursor: "pointer",
              }}
            />
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleChildClose}
              keepMounted
            >
              {isPagePermission("Allow Upload", "PreworkDetail", 160) &&
                tabValue !== 0 && (
                  <MenuItem
                    className="context-menu-item"
                    onClick={() => handleChildClose(0, rowData)}
                  >
                    Upload
                  </MenuItem>
                )}
              {isPagePermission("Allow Add Notes", "PreworkDetail", 159) &&
                tabValue !== 0 && (
                  <MenuItem
                    className="context-menu-item"
                    onClick={() => handleChildClose(1, rowData)}
                  >
                    Add Notes
                  </MenuItem>
                )}
              {rowData.parentDocumentStatus === 2 &&
                tabValue !== 0 &&
                isPagePermission("", "", 155) && (
                  <MenuItem
                    className="context-menu-item"
                    onClick={() => handleChildClose(6, rowData)}
                  >
                    Move to Preflight
                  </MenuItem>
                )}
              {isPagePermission("Allow Rename", "PreworkDetail", 157) &&
                tabValue !== 0 && (
                  <MenuItem
                    className="context-menu-item"
                    onClick={() => handleChildClose(2, rowData)}
                  >
                    Rename
                  </MenuItem>
                )}
              {isPagePermission("Allow Reject", "PreworkDetail", 158) &&
                tabValue !== 0 && (
                  <MenuItem
                    className="context-menu-item"
                    onClick={() => handleChildClose(3, rowData)}
                  >
                    Reject
                  </MenuItem>
                )}
              {isPagePermission("Allow Delete", "PreworkDetail", 167) && (
                <MenuItem
                  className="context-menu-item"
                  onClick={() => handleChildClose(4, rowData)}
                >
                  Delete
                </MenuItem>
              )}
              {rowData.parentDocumentStatus === 11 && tabValue !== 0 && (
                <MenuItem
                  className="context-menu-item"
                  onClick={() => handleChildClose(5, rowData)}
                >
                  Reprocess - Send to Preflight
                </MenuItem>
              )}
            </Menu>
          </>
        </div>
      );
    }
  };

  //Action parent cell renderer
  const ActionParentCellRenderer = (params: any) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const handleClick = (event: any) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = (actionType: number, rowData: any) => {
      if (actionType === 0) {
        //Upload
        handelUploadFiles(rowData, 0);
      } else if (actionType === 1) {
        //Add Notes
        handleAddNotes(rowData);
      } else if (actionType === 2) {
        //Reject
        handleReject(rowData);
      } else if (actionType === 3) {
        //Delete
        handleDelete(rowData, 0);
      } else if (actionType === 4) {
        //Reprocess to Preflight
        moveToPreflight(rowData, 0);
      } else if (actionType === 5) {
        // Trigger Proof WF
        moveToFinalFolder(rowData, 0, 2);
      } else if (actionType === 6) {
        // Trigger Prod WF
        moveToFinalFolder(rowData, 0, 3);
      } else if (actionType === 7) {
        //To Final Folder
        moveToFinalFolder(rowData, 0, 1);
      } else if (actionType === 8) {
        //Reprocess - Send to Preflight
        reprocessSendToPreflight(rowData);
      } else if (actionType === 10) {
        //Rename
        handleRename(rowData);
      } else if (actionType === 11) {
        //Move to Preflight
        moveToPreflight(rowData, 0);
      }
      setAnchorEl(null);
    };
    const rowData = params.data;
    if (params.data === undefined) {
      return "";
    } else {
      return (
        <div>
          {isPagePermission("", "", 154) && (
            <Tooltip title="Click here to download the documents">
              <IconButton
                style={{ padding: "2px" }}
                onClick={() => fileDownloadParent(rowData)}
              >
                <FileDownloadIcon className="icon-button-other" />
              </IconButton>
            </Tooltip>
          )}

          {isPagePermission("", "", 165) && (
            <Tooltip title="Click to view">
              <IconButton
                style={{ padding: "2px", color: "var(--aggrid-text-color)" }}
                onClick={() => viewDocumentParent(rowData)}
              >
                <VisibilityIcon className="icon-button-other" />
              </IconButton>
            </Tooltip>
          )}
          {(rowData.ChildList === undefined ||
            rowData.ChildList.length === 0) &&
            isPagePermission("", "", 166) && (
              <Tooltip title="Click to view the file information and history">
                <IconButton
                  style={{ padding: "2px", color: "var(--aggrid-text-color)" }}
                  onClick={() => infoDocument(rowData)}
                >
                  <InfoIcon className="icon-button-other" />
                </IconButton>
              </Tooltip>
            )}
          <>
            <MoreVertIcon
              className="editIcon"
              onClick={handleClick}
              style={{
                padding: "0.2vh",
                color: "var(--aggrid-text-color)",
                cursor: "pointer",
              }}
            />
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              keepMounted
            >
              {rowData.parentDocumentStatus !== 6 &&
                rowData.parentDocumentStatus !== 20 &&
                rowData.parentDocumentStatus !== 23 &&
                rowData.parentDocumentStatus !== 24 &&
                rowData.parentDocumentStatus !== 30 &&
                rowData.parentDocumentStatus !== 31 &&
                rowData.parentDocumentStatus !== 32 &&
                rowData.parentDocumentStatus !== 33 &&
                rowData.parentDocumentStatus !== 34 &&
                rowData.parentDocumentStatus !== 35 &&
                rowData.parentDocumentStatus !== 21 &&
                rowData.parentDocumentStatus !== 11 &&
                rowData.parentDocumentStatus !== 17 &&
                rowData.parentDocumentStatus !== 18 &&
                rowData.parentDocumentStatus !== 3 &&
                tabValue !== 0 &&
                isPagePermission("", "", 160) && (
                  <MenuItem
                    className="context-menu-item"
                    onClick={() => handleClose(0, rowData)}
                  >
                    Upload
                  </MenuItem>
                )}
              {rowData.parentDocumentStatus !== 20 &&
                rowData.parentDocumentStatus !== 23 &&
                rowData.parentDocumentStatus !== 24 &&
                rowData.parentDocumentStatus !== 21 &&
                rowData.parentDocumentStatus !== 30 &&
                rowData.parentDocumentStatus !== 33 &&
                rowData.parentDocumentStatus !== 34 &&
                rowData.parentDocumentStatus !== 35 &&
                tabValue !== 0 &&
                isPagePermission("", "", 159) && (
                  <MenuItem
                    className="context-menu-item"
                    onClick={() => handleClose(1, rowData)}
                  >
                    Add Notes
                  </MenuItem>
                )}
              {rowData.parentDocumentStatus === 2 &&
                tabValue !== 0 &&
                isPagePermission("", "", 155) && (
                  <MenuItem
                    className="context-menu-item"
                    onClick={() => handleClose(11, rowData)}
                  >
                    Move to Preflight
                  </MenuItem>
                )}
              {rowData.parentDocumentStatus !== 6 &&
                rowData.parentDocumentStatus !== 20 &&
                rowData.parentDocumentStatus !== 23 &&
                rowData.parentDocumentStatus !== 24 &&
                rowData.parentDocumentStatus !== 30 &&
                rowData.parentDocumentStatus !== 31 &&
                rowData.parentDocumentStatus !== 32 &&
                rowData.parentDocumentStatus !== 33 &&
                rowData.parentDocumentStatus !== 34 &&
                rowData.parentDocumentStatus !== 35 &&
                rowData.parentDocumentStatus !== 21 &&
                rowData.parentDocumentStatus !== 11 &&
                rowData.parentDocumentStatus !== 17 &&
                rowData.parentDocumentStatus !== 18 &&
                tabValue !== 0 &&
                isPagePermission("", "", 158) && (
                  <MenuItem
                    className="context-menu-item"
                    onClick={() => handleClose(2, rowData)}
                  >
                    Reject
                  </MenuItem>
                )}

              {isPagePermission("", "", 167) && (
                <MenuItem
                  className="context-menu-item"
                  onClick={() => handleClose(3, rowData)}
                >
                  Delete
                </MenuItem>
              )}
              {rowData.parentDocumentStatus === 6 && tabValue !== 0 && (
                <MenuItem
                  className="context-menu-item"
                  onClick={() => handleClose(4, rowData)}
                >
                  Reprocess to Preflight
                </MenuItem>
              )}
              {LocalStorageUtil.getItem("contextName")?.toLocaleLowerCase() !==
                appSettings.hideTriggerProfProdWFContextMenu &&
                (rowData.parentDocumentStatus === 11 ||
                  rowData.parentDocumentStatus === 18) &&
                isPagePermission("", "", 1328) && (
                  <MenuItem
                    className="context-menu-item"
                    onClick={() => handleClose(5, rowData)}
                  >
                    Trigger Proof WF
                  </MenuItem>
                )}
              {LocalStorageUtil.getItem("contextName")?.toLocaleLowerCase() !==
                appSettings.hideTriggerProfProdWFContextMenu &&
                (rowData.parentDocumentStatus === 11 ||
                  rowData.parentDocumentStatus === 18) &&
                isPagePermission("", "", 1329) && (
                  <MenuItem
                    className="context-menu-item"
                    onClick={() => handleClose(6, rowData)}
                  >
                    Trigger Prod WF
                  </MenuItem>
                )}
              {(rowData.parentDocumentStatus === 11 ||
                rowData.parentDocumentStatus === 18) &&
                tabValue !== 0 &&
                isPagePermission("", "", 156) && (
                  <MenuItem
                    className="context-menu-item"
                    onClick={() => handleClose(7, rowData)}
                  >
                    To Final Folder
                  </MenuItem>
                )}
              {rowData.parentDocumentStatus !== 18 &&
                tabValueInProgress === 11 &&
                tabValue !== 0 && (
                  <MenuItem
                    className="context-menu-item"
                    onClick={() => handleClose(8, rowData)}
                  >
                    Reprocess - Send to Preflight
                  </MenuItem>
                )}
              {rowData.parentDocumentStatus === 18 && tabValue !== 0 && (
                <MenuItem
                  className="context-menu-item"
                  onClick={() => handleClose(9, rowData)}
                >
                  Reprocess - Send to VIS
                </MenuItem>
              )}
              {(tabValue === 1 || tabValue === 2) &&
                rowData.parentDocumentStatus !== 6 &&
                rowData.parentDocumentStatus !== 11 &&
                rowData.parentDocumentStatus !== 17 &&
                rowData.parentDocumentStatus !== 18 &&
                rowData.parentDocumentStatus !== 30 &&
                rowData.parentDocumentStatus !== 31 &&
                rowData.parentDocumentStatus !== 32 &&
                rowData.parentDocumentStatus !== 33 &&
                rowData.parentDocumentStatus !== 34 &&
                rowData.parentDocumentStatus !== 35 &&
                (rowData.ChildList === undefined ||
                  rowData.ChildList.length === 0) &&
                isPagePermission("", "", 157) && (
                  <MenuItem
                    className="context-menu-item"
                    onClick={() => handleClose(10, rowData)}
                  >
                    Rename
                  </MenuItem>
                )}
            </Menu>
          </>
        </div>
      );
    }
  };

  // Detail row data getter for child grid
  const getDetailRowData = useCallback((params: any) => {
    params.successCallback(params.data.ChildList);
  }, []);

  // Detail cell renderer params for child grid
  const detailCellRendererParams = useMemo(
    () => ({
      detailGridOptions: {
        columnDefs: childColumnDefs,
        defaultColDef: {
          minWidth: 100,
        },
        rowSelection: "multiple",
        suppressRowClickSelection: true,
      },
      getDetailRowData,
    }),
    [childColumnDefs, getDetailRowData]
  );

  // Define columns to exclude for Parent and child grid
  const columnsToExclude = [
    "RowNum",
    "parentDocumentID",
    "childDocumentID",
    "parentDocumentStreamID",
    "childFileDocumentStreamID",
    "projectDocumentId",
    "parentFilename",
    "parentDocumenStatusName",
    "childDocumenStatusName",
    "childAcceptedId",
    "parentDocumentStatus",
    "childFileName",
    "parentDocumentDescription",
    "parentManagerID",
    "parentManagerName",
    "parentSupplierTrackingId",
    "parentWorkOrderSubmittedDate",
    "parentSupplierDueDate",
    "parentComments",
    "childFileType",
    "childFileDocumenttype",
    "childFileQueueType",
    "childCount",
    "newCounts",
    "inprogressCounts",
    "topreflight",
    "fromPreflight",
    "completedCounts",
    "allCounts",
    "rejectedCounts",
    "tovsiCounts",
    "fromVsiCounts",
    "fromPreflightJobNumber",
    "toPreflightJobNumber",
    "finalDocID",
    "finalDocumentid",
    "rejectRemarks",
    "renameRemarks",
    "resolutionStatus",
    "fileSize",
    "isDoccount",
    "isStreamcount",
    "preWorkDocumentID",
    "toPreflightZipName",
    "preworkDynamicFilename",
    "recordCounts",
    "ChildList",
  ];

  // Rename the columns for Parent and child grid
  const renameColumns = (val: any) => {
    if (val !== undefined) {
      if (val.toLowerCase() === "filename") {
        return "File Name";
      } else if (val.toLowerCase() === "uploadedon") {
        return "Uploaded On";
      } else if (val.toLowerCase() === "uploadby") {
        return "Uploaded By";
      } else if (val.toLowerCase() === "acceptedon") {
        return "Accepted On";
      } else if (val.toLowerCase() === "acceptedby") {
        return "Accepted By";
      } else {
        return val.replace(/&amp;/, "&");
      }
    }
  };

  // #region Action buttons events
  //Open Notes Pop up
  const viewParentNotes = (rowData: any) => {
    if (gridRef.current) {
      setNotesOpen(true);
      setNotesData(rowData.data);
      setType("Parent");
    }
  };

  const viewChildNotes = (rowData: any) => {
    if (gridRef.current) {
      setNotesOpen(true);
      setNotesData(rowData.data);
      setType("Child");
    }
  };

  // Close notes popup
  const closeNotesPopup = () => {
    setNotesOpen(false);
    setNotesData(null);
  };

  //Info Document - Action buttons events
  const infoDocument = (rowData: any) => {
    setSelectedDocument(rowData);
    setDrawerOpen(true);
  };

  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };

  // View Document - Action buttons events
  const viewDocument = (rowData: any) => {
    const id = rowData.childFileDocumentStreamID;
    const encodedId = btoa(id);
    const fileName = rowData.Filename.replace(/\.[^/.]+$/, "");
    const url = !urlConfig.isDeployed
      ? `/documentviewer/${encodedId}?FileName=${fileName}`
      : `/docdistrov2/documentviewer/${encodedId}?FileName=${fileName}`;
    popupCenter(url, "Document Viewer", 1100, 550);
  };

  // File Download - Action buttons events
  const fileDownload = async (params: any) => {
    try {
      setLoading(true);
      const objDownloadFile: PreworkDetailDownloadFileModel = {
        DocumentStreamId: params.childFileDocumentStreamID,
        FileName: params.Filename,
        AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
        ContextName: LocalStorageUtil.getItem("contextName") ?? "",
      };
      const response = await GetDownloadFiles([objDownloadFile]);
      if (response.status === 200) {
        setLoading(false);
        const data = response.data;
        const contentType = response.headers["content-type"];
        const linkElement = document.createElement("a");
        const blob = new Blob([data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        linkElement.href = url;
        linkElement.setAttribute("download", params.Filename);
        const clickEvent = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        linkElement.dispatchEvent(clickEvent);
      }
      if (response) {
        showSnackbar("Documents downloaded successfully");
      } else {
        showSnackbar("Unable to download file !");
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  // Donwload file pop up
  const popupCenter = (url: string, title: string, w: number, h: number) => {
    const dualScreenLeft = window.screenLeft ?? window.screenX ?? 0;
    const dualScreenTop = window.screenTop ?? window.screenY ?? 0;

    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      window.screen.width;

    const height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      window.screen.height;

    const left = width / 3 - w / 3 + dualScreenLeft;
    const top = height / 3 - h / 3 + dualScreenTop;
    const newWindow = window.open(
      url,
      title,
      `readonly=true, scrollbars=yes, width=${w}, height=${h}, top=${top}, left=${left}`
    );
    if (newWindow) {
      newWindow.focus();
    }
  };

  // File Download Parent - Action buttons events

  const fileDownloadParent = async (params: any) => {
    try {
      setLoading(true);

      if (!gridRef.current) return;

      // 1. Get selected rows from master grid
      const selectedMasterRows = gridRef.current.api.getSelectedRows();

      // 2. Get selected rows from all detail grids
      let selectedDetailRows: any[] = [];
      gridRef.current.api.forEachNode((node: any) => {
        if (node.detailNode?.detailGridInfo?.api) {
          const detailSelected =
            node.detailNode.detailGridInfo.api.getSelectedRows();
          if (detailSelected.length > 0) {
            selectedDetailRows = selectedDetailRows.concat(detailSelected);
          }
        }
      });

      // 3. Combine all selected rows
      const allSelectedRows = [...selectedMasterRows, ...selectedDetailRows];

      if (allSelectedRows.length === 0) {
        showSnackbar("Please select at least one file to download.", true);
        return;
      }

      if (allSelectedRows.length === 1) {
        await fileDownload(params);
        return;
      }
      // 4. Map to download model
      const downloadList = allSelectedRows.map((row: any) => ({
        DocumentStreamId: row.childFileDocumentStreamID,
        filename: row.Filename,
        AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
        contextName: LocalStorageUtil.getItem("contextName") ?? "",
      }));

      // 5. Call your download API
      showSnackbar("Download Started");
      const response = await GetDownloadFiles(downloadList);
      if (response.status === 200) {
        const data = response.data;
        const contentType =
          response.headers["content-type"] || "application/zip";
        const fileName =
          "PreWork_DD" + moment().format("YYYYMMDDHHMMSS") + ".zip";
        const linkElement = document.createElement("a");
        const blob = new Blob([data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        linkElement.href = url;
        linkElement.setAttribute("download", fileName);
        const clickEvent = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        linkElement.dispatchEvent(clickEvent);
        showSnackbar("Documents downloaded successfully");
      } else {
        showSnackbar("Unable to download file!", true);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  // View Document Parent - Action buttons events
  const viewDocumentParent = (params: any) => {
    try {
      if (params.ChildList === undefined || params.ChildList.length === 0) {
        viewDocument(params);
      } else {
        //Open Popup for file view
        setDocViewOpen(true);
        setDocViewData(params);
      }
    } catch (error) {}
  };

  // #endregion

  // Date validation
  const handleDateChange = (date: Date | null, type: string) => {
    if (type === "startDate") {
      setStartDate(date);
    } else if (type === "endDate") {
      setEndDate(date);
    }
    if (date === null) {
      setValidationMessage("Please select a date.");
    } else {
      setValidationMessage(null);
    }
  };

  // Open Upload Files Pop up
  const handelUploadFiles = (rowData: any, value: number) => {
    setUploadFilesOpen(true);
    setUploadFilesData(rowData);
  };

  // Close Upload Files Pop up
  const closeUploadFiles = (isCancelClick: boolean) => {
    setUploadFilesOpen(false);
    if (!isCancelClick) {
      handleFromSourceTabClick(1, "FROM SOURCE");
    }
  };

  // Open Add Notes Pop up
  const handleAddNotes = (rowData: any) => {
    setAddNotesOpen(true);
    setAddNotesData(rowData);
  };

  // Close Add Notes Pop up
  const closeAddNotes = (isCancelClick: boolean, tabValue?: number) => {
    setAddNotesOpen(false);
    if (!isCancelClick) {
      setInProgressTabType(tabValue ?? 2);
      refreshGridData();
    }
  };

  //Open Rename Pop up
  const handleRename = (rowData: any) => {
    setRenamePopupOpen(true);
    setRenameData(rowData);
  };

  //Close Rename Pop up
  const closeRenamePopup = (isCancelClick: boolean, tabValue?: number) => {
    setRenamePopupOpen(false);
    if (!isCancelClick) {
      setInProgressTabType(tabValue ?? 2);
      refreshGridData();
    }
  };

  //Open Reject Pop up
  const handleReject = (rowData: any) => {
    setLoading(true);
    try {
      let preworkDetailViewModel: PreworkDetailViewModel[] = [];
      if (gridRef.current) {
        let selectedRows = gridRef.current.api.getSelectedRows();
        if (Array.isArray(selectedRows) && selectedRows.length > 0) {
          selectedRows.forEach((element: any) => {
            const objRejectFile: PreworkDetailViewModel = {
              CheckBoxDocumentId: element.childFileDocumentStreamID,
              CheckBoxDocumentStreamId: element.childFileDocumentStreamID,
              AccepectId: element.childAcceptedId,
              DocumentStatus: element.parentDocumentStatus,
              AccntId: Number(LocalStorageUtil.getItem("accountId")) || 0,
              UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
              Remarks: "",
              ParentFileName: element.parentFilename,
              ChildFilename: element.Filename,
              ParentChildId: element.childDocumentID,
              ChildCount: element.childCount,
              PageType: element.childFileType,
              ChildFileType: element.childFileType,
              QueueType: element.childFileQueueType,
              ProjDocumentId: element.projectDocumentId,
              ContextName: LocalStorageUtil.getItem("contextName") ?? "",
            };
            preworkDetailViewModel.push(objRejectFile);
          });
        } else {
          const objRejectFile: PreworkDetailViewModel = {
            CheckBoxDocumentId: rowData.childFileDocumentStreamID,
            CheckBoxDocumentStreamId: rowData.childFileDocumentStreamID,
            AccepectId: rowData.childAcceptedId,
            DocumentStatus: rowData.parentDocumentStatus,
            AccntId: Number(LocalStorageUtil.getItem("accountId")) || 0,
            UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
            Remarks: "",
            ParentFileName: rowData.parentFilename,
            ChildFilename: rowData.Filename,
            ParentChildId: rowData.childDocumentID,
            ChildCount: rowData.childCount,
            PageType: rowData.childFileType,
            ChildFileType: rowData.childFileType,
            QueueType: rowData.childFileQueueType,
            ProjDocumentId: rowData.projectDocumentId,
            ContextName: LocalStorageUtil.getItem("contextName") ?? "",
          };
          preworkDetailViewModel.push(objRejectFile);
        }
      } else {
        const objRejectFile: PreworkDetailViewModel = {
          CheckBoxDocumentId: rowData.childFileDocumentStreamID,
          CheckBoxDocumentStreamId: rowData.childFileDocumentStreamID,
          AccepectId: rowData.childAcceptedId,
          DocumentStatus: rowData.parentDocumentStatus,
          AccntId: Number(LocalStorageUtil.getItem("accountId")) || 0,
          UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
          Remarks: "",
          ParentFileName: rowData.parentFilename,
          ChildFilename: rowData.Filename,
          ParentChildId: rowData.childDocumentID,
          ChildCount: rowData.childCount,
          PageType: rowData.childFileType,
          ChildFileType: rowData.childFileType,
          QueueType: rowData.childFileQueueType,
          ProjDocumentId: rowData.projectDocumentId,
          ContextName: LocalStorageUtil.getItem("contextName") ?? "",
        };
        preworkDetailViewModel.push(objRejectFile);
      }

      if (preworkDetailViewModel.length > 0) {
        setRejectPopupOpen(true);
        setRejectData(preworkDetailViewModel);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  //Close Reject Pop up
  const closeRejectPopup = (isCancelClick: boolean, tabValue?: number) => {
    setRejectPopupOpen(false);
    if (!isCancelClick) {
      setInProgressTabType(tabValue ?? 2);
      refreshGridData();
    }
  };

  // Helper function to build delete file object
  const buildDeleteFileObject = (element: any): PreworkDetailViewModel => {
    return {
      CheckBoxDocumentId: element.childFileDocumentStreamID,
      CheckBoxDocumentStreamId: element.childFileDocumentStreamID,
      AccepectId: element.childAcceptedId,
      DocumentStatus: element.parentDocumentStatus,
      AccntId: Number(LocalStorageUtil.getItem("accountId")) || 0,
      UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
      Remarks: "",
      ParentFileName: element.parentFilename,
      ChildFilename: element.Filename,
      ParentChildId: element.childDocumentID,
      ChildCount: element.childCount,
      PageType: element.childFileType,
      ChildFileType: element.childFileType,
      QueueType: element.childFileQueueType,
      ProjDocumentId: element.projectDocumentId,
      ContextName: LocalStorageUtil.getItem("contextName") ?? "",
    };
  };

  // Helper function to process selected rows for deletion
  const processDeleteRows = (
    selectedRows: any[],
    rowData: any
  ): PreworkDetailViewModel[] => {
    const preworkDetailViewModel: PreworkDetailViewModel[] = [];

    if (Array.isArray(selectedRows) && selectedRows.length > 0) {
      selectedRows.forEach((element: any) => {
        preworkDetailViewModel.push(buildDeleteFileObject(element));
      });
    } else {
      preworkDetailViewModel.push(buildDeleteFileObject(rowData));
    }

    return preworkDetailViewModel;
  };

  // Helper function to open delete confirmation dialog
  const openDeleteConfirmation = (
    preworkDetailViewModel: PreworkDetailViewModel[],
    setdeleteConfirmationDialogOpen: (open: boolean) => void,
    setDeleteDocumentData: (data: PreworkDetailViewModel[]) => void
  ) => {
    if (preworkDetailViewModel.length > 0) {
      setdeleteConfirmationDialogOpen(true);
      setDeleteDocumentData(preworkDetailViewModel);
    }
  };

  // Refactored handleDelete function
  const handleDelete = (rowData: any, documentStatus: number) => {
    try {
      if (!gridRef.current) return;

      const selectedRows = gridRef.current.api.getSelectedRows();
      const preworkDetailViewModel = processDeleteRows(selectedRows, rowData);

      openDeleteConfirmation(
        preworkDetailViewModel,
        setdeleteConfirmationDialogOpen,
        setDeleteDocumentData
      );
    } catch (error) {
      console.error("Error in handleDelete:", error);
    }
  };

  // Close delete confirmation pop up
  const closeConfirmationDialogbox = (isCancelClick: boolean) => {
    setdeleteConfirmationDialogOpen(false);
    setDeleteDocumentData(null);
    tabValue = documentStatusValue;
    if (!isCancelClick) {
      tabMenu(documentStatusValue, null, null);
    }
  };

  // Open Move to Preflight Pop up
  const createPreworkDetail = (
    element: any
  ): PreworkSummaryListDetailchildModel => {
    return {
      ParentDocumentID: element.parentDocumentID,
      ParentDocumentStreamID: element.childFileDocumentStreamID,
      ChildFileName: element.childFileName,
      AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
      FromPreflightJobNumber: element.fromPreflightJobNumber,
      FinalDocumentId: element.finalDocumentid,
      ContextName: LocalStorageUtil.getItem("contextName") ?? "",
      ToPreflightJobNumber: element.toPreflightJobNumber,
      UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
      ExcelNotes: undefined,
      ChildFileUploadedon: undefined,
      ChildUploadBy: undefined,
      ChildFileAcceptedDate: undefined,
      ChildAcceptedBy: undefined,
      ChildDocumenStatusName: undefined,
      ChildFileType: undefined,
      ChildFileDocumentType: undefined,
      ChildFileQueueType: undefined,
      ChildFileDocumentStreamId: undefined,
      ChildDocumentId: undefined,
      IsChecked: undefined,
      IsDocCount: undefined,
      IsStreamCount: undefined,
      Timezone: undefined,
      PreworkDynamicFilename: undefined,
      IsFinal: undefined,
      InstructionText: undefined,
      InstructionCreatedBy: undefined,
      InstructionCreatedOn: undefined,
      InstructionDownloadName: undefined,
      InstructionFileType: undefined,
      InstructionId: undefined,
      InstructionStreamBytes: undefined,
      Filename: undefined,
      RenameRemarks: undefined,
      RejectRemarks: undefined,
      ResolutionStatus: undefined,
      ChildCount: undefined,
      FileSize: undefined,
      ChildAcceptedId: undefined,
      AddNotesEmail: undefined,
    };
  };

  // Helper function to check if element is valid for preflight
  const isValidForPreflight = (element: any, rowData?: any): boolean => {
    if (rowData?.parentDocumentStatus === 6) {
      return true;
    }
    return (
      element.childFileDocumenttype !== 2 && element.parentDocumentStatus !== 20
    );
  };

  // Helper function to process selected parent rows
  const processParentRows = (
    selectedRows: any[],
    rowData: any
  ): PreworkSummaryListDetailchildModel[] => {
    const preworkDetails: PreworkSummaryListDetailchildModel[] = [];

    if (selectedRows.length > 0) {
      selectedRows.forEach((element: any) => {
        if (isValidForPreflight(element, rowData)) {
          preworkDetails.push(createPreworkDetail(element));
        }
      });
    } else {
      preworkDetails.push(createPreworkDetail(rowData));
    }

    return preworkDetails;
  };

  // Helper function to process child list
  const processChildList = (
    childList: any[]
  ): PreworkSummaryListDetailchildModel[] => {
    const preworkDetails: PreworkSummaryListDetailchildModel[] = [];

    childList.forEach((element: any) => {
      if (element.childFileDocumenttype !== 2) {
        preworkDetails.push(createPreworkDetail(element));
      }
    });

    return preworkDetails;
  };

  // Helper function to process child grid rows
  const processChildGridRows = (
    gridRef: any,
    rowData: any
  ): { details: PreworkSummaryListDetailchildModel[]; shouldShow: boolean } => {
    let preworkDetails: PreworkSummaryListDetailchildModel[] = [];
    let shouldShowPopup = false;

    gridRef?.current?.api.forEachNode((node: any) => {
      if (node.detailNode) {
        const detailGrid = node.detailNode.detailGridInfo.api;
        const selectedChildRows = detailGrid.getSelectedRows();

        if (selectedChildRows.length > 0) {
          selectedChildRows.forEach((element: any) => {
            preworkDetails.push(createPreworkDetail(element));
          });
          shouldShowPopup = true;
        }
      }
    });

    // If no child rows selected, use rowData
    if (!shouldShowPopup) {
      preworkDetails = [createPreworkDetail(rowData)];
      shouldShowPopup = true;
    }

    return { details: preworkDetails, shouldShow: shouldShowPopup };
  };

  // Helper function to show alert for Excel files
  const checkForExcelFiles = (rowData: any): boolean => {
    if (rowData.parentDocumentStatus === 2 && rowData.childCount === 1) {
      const fileType = rowData.ChildList?.[0]?.childFileType?.toLowerCase();
      if (fileType === ".xls" || fileType === ".xlsx") {
        alert("Please Note, No pdf is available in the selection");
        return true;
      }
    }
    return false;
  };

  // Refactored moveToPreflight function
  const moveToPreflight = (rowData: any, value: number) => {
    try {
      if (!gridRef.current) return;

      let preworkDetails: PreworkSummaryListDetailchildModel[] = [];

      if (value === 0) {
        // Parent grid processing
        if (checkForExcelFiles(rowData)) return;

        const selectedRows = gridRef.current.api.getSelectedRows();

        // Get selected child rows from detail grids
        let selectedChildRows: any[] = [];
        gridRef.current.api.forEachNode((node: any) => {
          if (node.detailNode?.detailGridInfo?.api) {
            const detailGrid = node.detailNode.detailGridInfo.api;
            const childRows = detailGrid.getSelectedRows();
            if (childRows.length > 0) {
              selectedChildRows = selectedChildRows.concat(childRows);
            }
          }
        });

        // Process parent rows
        if (selectedRows.length > 0) {
          preworkDetails = processParentRows(selectedRows, rowData);
        } else if (!rowData.ChildList || rowData.ChildList.length === 0) {
          preworkDetails = processParentRows([], rowData);
        } else {
          preworkDetails = processChildList(rowData.ChildList);
        }

        // Add selected child rows to preworkDetails
        if (selectedChildRows.length > 0) {
          const childDetails = selectedChildRows.map((child: any) =>
            createPreworkDetail(child)
          );
          preworkDetails = preworkDetails.concat(childDetails);
        }
      } else {
        // Child grid processing
        const result = processChildGridRows(gridRef, rowData);
        preworkDetails = result.details;

        if (!result.shouldShow) {
          alert("No child selected");
          return;
        }
      }

      if (preworkDetails.length > 0) {
        const objMoveToPreflight: PreworkSummaryListDetails = {
          PreworkDetails: preworkDetails,
          InstructionId: undefined,
          ToPreflighJobNo: undefined,
          ReprocessDocumentStatus: undefined,
          IsCheckClient: undefined,
          ContextName: LocalStorageUtil.getItem("contextName") ?? "",
        };

        setMoveToPreflightOpen(true);
        setMoveToPreflightData(objMoveToPreflight);
      }
    } catch (error) {
      console.error("Error in moveToPreflight:", error);
    }
  };

  // Close Move to Preflight Pop up
  const closeMoveToPreflight = (isCancelClick: boolean, tabValue?: number) => {
    setMoveToPreflightOpen(false);
    if (!isCancelClick) {
      setInProgressTabType(tabValue ?? 2);
      refreshGridData();
    }
  };

  // Open Move to Final Folder, Trigger Proof WF, Trigger Prod WF Pop up
  const moveToFinalFolder = async (
    rowData: any,
    value: number,
    status: number
  ) => {
    try {
      let PreworkDetails: PreworkSummaryListDetailsViewModel[] = [];
      setContextMenuType(status);
      if (status === 1) {
        // To Final Folder
        setMoveToFinalPopupTitle("Move to Final");
      } else if (status === 2) {
        // Trigger proof WF
        setMoveToFinalPopupTitle("Trigger Proof Workflow");
      } else if (status === 3) {
        // Trigger proof WF
        setMoveToFinalPopupTitle("Trigger Prod Workflow");
      }
      if (value === 0) {
        //Parent
        if (gridRef.current) {
          let selectedRows = gridRef.current.api.getSelectedRows();
          if (selectedRows.length > 0) {
            selectedRows.forEach((element: any) => {
              const objMoveToFinalFolder: PreworkSummaryListDetailsViewModel = {
                ParentFilename: element.parentFilename,
                ProjectDocumentId: element.projectDocumentId,
                ParentProjectReference: element.parentProjectReference,
                ParentWorkArea: element.parentWorkArea,
                ParentDocumentUploadedon: element.parentDocumentUploadedon,
                ParentUploadBy: element.parentUploadBy,
                ParentAcceptedDate: element.parentAcceptedDate,
                ParentDate: element.parentDate,
                ParentAcceptedBy: element.parentAcceptedBy,
                ParentDocumenStatusName: element.parentDocumenStatusName,
                ParentDocumentStatus: 0,
                ParentDocumentId: element.childDocumentID,
                FromDate: null,
                ToDate: null,
                Timezone: appSettings.timezone,
                NoOfRecords: 0,
                CurrentPage: 0,
                SortColumn: undefined,
                SortOrder: 1,
                TotalRecords: 0,
                IsExportToExcel: false,
                OverWriteFlag: 0,
                AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
                UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
                QueueType: null,
                DocumentStatus: null,
                DatebaseDocId: 0,
                Search: null,
                OverrideStreamId: "",
                CreatedBy: "",
                ChildCount: 0,
                IsChecked: false,
                DocumentStreamId: element.childFileDocumentStreamID,
                ParentManagerId: 0,
                ToPreflightZipName: "",
                ManagerName: "",
                ParentSupplierTrackingId: "",
                ParentDocumentDescription: "",
                ParentWorkOrderSubmittedDate: null,
                ParentSupplierDueDate: null,
                ParentComments: "",
                FinalDocumentId: element.finalDocumentid,
                IsCheckExcel: false,
                IsDocCount: 0,
                IsStreamCount: 0,
                FromPreflightJobNumber: "",
                ToPreflightJobNumber: "",
                ParentInstructiontext: "",
                ParentInstructionCreatedBy: "",
                ParentInstructionCreatedon: null,
                ParentInstructionDownloadName: "",
                ParentInstructionId: 0,
                ChildFileType: "",
                ParentFileSize: 0,
                ChildLIst: element.ChildList,
                FileName: element.Filename,
                IsConsolatedView: false,
                DocumentStatusIds: undefined,
                ToPreflight: 0,
                FromPreflight: undefined,
                CompletedCounts: undefined,
                FileFormat: undefined,
                ToVisCounts: undefined,
                FromVisCounts: undefined,
                IsCheckClient: undefined,
                DocumentStatusId: undefined,
                ContextName: LocalStorageUtil.getItem("contextName") ?? "",
              };
              PreworkDetails.push(objMoveToFinalFolder);
            });
          } else {
            const objMoveToFinalFolder: PreworkSummaryListDetailsViewModel = {
              ParentFilename: rowData.parentFilename,
              ProjectDocumentId: rowData.projectDocumentId,
              ParentProjectReference: rowData.parentProjectReference,
              ParentWorkArea: rowData.parentWorkArea,
              ParentDocumentUploadedon: rowData.parentDocumentUploadedon,
              ParentUploadBy: rowData.parentUploadBy,
              ParentAcceptedDate: rowData.parentAcceptedDate,
              ParentDate: rowData.parentDate,
              ParentAcceptedBy: rowData.parentAcceptedBy,
              ParentDocumenStatusName: rowData.parentDocumenStatusName,
              ParentDocumentStatus: 0,
              ParentDocumentId: rowData.childDocumentID,
              FromDate: null,
              ToDate: null,
              Timezone: appSettings.timezone,
              NoOfRecords: 0,
              CurrentPage: 0,
              SortColumn: undefined,
              SortOrder: 1,
              TotalRecords: 0,
              IsExportToExcel: false,
              OverWriteFlag: 0,
              AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
              UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
              QueueType: null,
              DocumentStatus: null,
              DatebaseDocId: 0,
              Search: null,
              OverrideStreamId: "",
              CreatedBy: "",
              ChildCount: 0,
              IsChecked: false,
              DocumentStreamId: rowData.childFileDocumentStreamID,
              ParentManagerId: 0,
              ToPreflightZipName: "",
              ManagerName: "",
              ParentSupplierTrackingId: "",
              ParentDocumentDescription: "",
              ParentWorkOrderSubmittedDate: null,
              ParentSupplierDueDate: null,
              ParentComments: "",
              FinalDocumentId: rowData.finalDocumentid,
              IsCheckExcel: false,
              IsDocCount: 0,
              IsStreamCount: 0,
              FromPreflightJobNumber: "",
              ToPreflightJobNumber: "",
              ParentInstructiontext: "",
              ParentInstructionCreatedBy: "",
              ParentInstructionCreatedon: null,
              ParentInstructionDownloadName: "",
              ParentInstructionId: 0,
              ChildFileType: "",
              ParentFileSize: 0,
              ChildLIst: rowData.ChildList,
              FileName: rowData.Filename,
              IsConsolatedView: false,
              DocumentStatusIds: undefined,
              ToPreflight: 0,
              FromPreflight: undefined,
              CompletedCounts: undefined,
              FileFormat: undefined,
              ToVisCounts: undefined,
              FromVisCounts: undefined,
              IsCheckClient: undefined,
              DocumentStatusId: undefined,
              ContextName: LocalStorageUtil.getItem("contextName") ?? "",
            };
            PreworkDetails.push(objMoveToFinalFolder);
          }
          if (PreworkDetails.length > 0) {
            setMoveToFinalFolderOpen(true);
            setMoveToFinalFolderData(PreworkDetails);
          }
        }
      }
    } catch (error) {}
  };

  // Close Move to Final Folder, Trigger Proof WF, Trigger Prod WF Pop up
  const closeMoveToFinalFolder = (
    isCancelClick: boolean,
    tabValue?: number
  ) => {
    setMoveToFinalFolderOpen(false);
    if (!isCancelClick) {
      setInProgressTabType(tabValue ?? 2); // Default to 2 if tabValue is undefined
      refreshGridData();
    }
  };

  // Open Reprocess Send to Preflight Pop up
  const reprocessSendToPreflight = async (rowData: any) => {
    try {
      let preworkSummaryListDetailchildModel: PreworkSummaryListDetailchildModel[] =
        [];
      if (gridRef.current) {
        let selectedRows = gridRef.current.api.getSelectedRows();
        if (selectedRows.length > 0) {
          selectedRows.forEach((element: any) => {
            if (element.childFileDocumenttype !== 2) {
              const preworkDetail: PreworkSummaryListDetailchildModel = {
                ParentDocumentID: element.parentDocumentID,
                ParentDocumentStreamID: element.parentDocumentStreamID,
                ChildFileName: element.childFileName,
                AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
                FromPreflightJobNumber: element.fromPreflightJobNumber,
                FinalDocumentId: element.finalDocumentid,
                ContextName: LocalStorageUtil.getItem("contextName") ?? "",
                ExcelNotes: undefined,
                ChildFileUploadedon: undefined,
                ChildUploadBy: undefined,
                ChildFileAcceptedDate: undefined,
                ChildAcceptedBy: undefined,
                ChildDocumenStatusName: undefined,
                ChildFileType: undefined,
                ChildFileDocumentType: undefined,
                ChildFileQueueType: undefined,
                ChildFileDocumentStreamId: element.childFileDocumentStreamID,
                ChildDocumentId: undefined,
                IsChecked: undefined,
                ToPreflightJobNumber: element.toPreflightJobNumber,
                IsDocCount: undefined,
                IsStreamCount: undefined,
                Timezone: undefined,
                PreworkDynamicFilename: undefined,
                UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
                IsFinal: undefined,
                InstructionText: undefined,
                InstructionCreatedBy: undefined,
                InstructionCreatedOn: undefined,
                InstructionDownloadName: undefined,
                InstructionFileType: undefined,
                InstructionId: undefined,
                InstructionStreamBytes: undefined,
                Filename: element.Filename,
                RenameRemarks: undefined,
                RejectRemarks: undefined,
                ResolutionStatus: undefined,
                ChildCount: undefined,
                FileSize: undefined,
                ChildAcceptedId: undefined,
                AddNotesEmail: undefined,
              };
              preworkSummaryListDetailchildModel.push(preworkDetail);
            }
          });
        } else {
          const preworkDetail: PreworkSummaryListDetailchildModel = {
            ParentDocumentID: rowData.parentDocumentID,
            ParentDocumentStreamID: rowData.parentDocumentStreamID,
            ChildFileName: rowData.childFileName,
            AccountId: Number(LocalStorageUtil.getItem("accountId")) || 0,
            FromPreflightJobNumber: rowData.fromPreflightJobNumber,
            FinalDocumentId: rowData.finalDocumentid,
            ContextName: LocalStorageUtil.getItem("contextName") ?? "",
            ExcelNotes: undefined,
            ChildFileUploadedon: undefined,
            ChildUploadBy: undefined,
            ChildFileAcceptedDate: undefined,
            ChildAcceptedBy: undefined,
            ChildDocumenStatusName: undefined,
            ChildFileType: undefined,
            ChildFileDocumentType: undefined,
            ChildFileQueueType: undefined,
            ChildFileDocumentStreamId: rowData.childFileDocumentStreamID,
            ChildDocumentId: undefined,
            IsChecked: undefined,
            ToPreflightJobNumber: rowData.toPreflightJobNumber,
            IsDocCount: undefined,
            IsStreamCount: undefined,
            Timezone: undefined,
            PreworkDynamicFilename: undefined,
            UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
            IsFinal: undefined,
            InstructionText: undefined,
            InstructionCreatedBy: undefined,
            InstructionCreatedOn: undefined,
            InstructionDownloadName: undefined,
            InstructionFileType: undefined,
            InstructionId: undefined,
            InstructionStreamBytes: undefined,
            Filename: rowData.Filename,
            RenameRemarks: undefined,
            RejectRemarks: undefined,
            ResolutionStatus: undefined,
            ChildCount: undefined,
            FileSize: undefined,
            ChildAcceptedId: undefined,
            AddNotesEmail: undefined, // Add this line to set the value to null
          };
          preworkSummaryListDetailchildModel.push(preworkDetail);
        }
      }
      const objReprocessSendToPreflight: PreworkSummaryListDetails = {
        PreworkDetails: preworkSummaryListDetailchildModel,
        InstructionId: undefined,
        ToPreflighJobNo: undefined,
        ReprocessDocumentStatus: undefined,
        IsCheckClient: undefined,
        ContextName: LocalStorageUtil.getItem("contextName") ?? "",
      };

      if (objReprocessSendToPreflight !== null) {
        setReprocessSendToPreflightOpen(true);
        setReprocessSendToPreflightData(objReprocessSendToPreflight);
      }
    } catch (error) {}
  };

  // Close Reprocess Send to Preflight Pop up
  const closeReprocessSendToPreflight = (
    isCancelClick: boolean,
    tabValue?: number
  ) => {
    setReprocessSendToPreflightOpen(false);
    if (!isCancelClick) {
      setInProgressTabType(tabValue ?? 2); // Default to 2 if tabValue is undefined
      refreshGridData();
    }
  };

  const closeDocviewPopup = (isCancelClick: boolean) => {
    setDocViewOpen(false);
    setDocViewData(null);
    if (!isCancelClick) {
      handleFromSourceTabClick(1, "FROM SOURCE");
    }
  };

  // Accept Click
  const handleAcceptClick = async () => {
    try {
      if (gridRef.current) {
        let selectedChildRows: any[] = [];
        let selectedRows = gridRef.current.api.getSelectedRows();
        let childSelected = false;

        // Get all selected child rows from detail grids
        if (gridRef?.current) {
          gridRef?.current?.api.forEachNode((node: any) => {
            if (node.detailNode?.detailGridInfo?.api) {
              const detailGrid = node.detailNode.detailGridInfo.api;
              const childRows = detailGrid.getSelectedRows();
              if (childRows.length > 0) {
                selectedChildRows = selectedChildRows.concat(childRows);
                childSelected = true;
              }
            }
          });
        }

        // Combine selected parent rows and child rows
        const allSelectedRows = [...selectedRows];
        if (selectedChildRows.length > 0) {
          allSelectedRows.push(...selectedChildRows);
        }

        if (allSelectedRows.length === 0) {
          showSnackbar("Please select at least one document to accept", true);
        } else {
          setValidateAccept(null);
          acceptRecords(allSelectedRows);
        }
      }
    } catch (error) {
      console.error("Error in handleAcceptClick:", error);
    }
  };

  // Accept method
  const acceptRecords = async (selectedRows: any) => {
    try {
      setLoading(true);
      let preworkDetailViewModel: PreworkDetailViewModel[] = [];
      selectedRows.forEach((element: any) => {
        const objAcceptFile: PreworkDetailViewModel = {
          CheckBoxDocumentId: element.childFileDocumentStreamID,
          CheckBoxDocumentStreamId: element.childFileDocumentStreamID,
          AccepectId: Number(LocalStorageUtil.getItem("userId")) || 0,
          DocumentStatus: element.parentDocumentStatus,
          AccntId: Number(LocalStorageUtil.getItem("accountId")) || 0,
          UserId: Number(LocalStorageUtil.getItem("userId")) || 0,
          Remarks: "",
          ParentFileName: element.parentFilename,
          ChildFilename: element.Filename,
          ParentChildId: element.childDocumentID,
          ChildCount: element.childCount,
          PageType: element.childFileType,
          ChildFileType: element.childFileType,
          QueueType: element.childFileQueueType,
          ProjDocumentId: element.projectDocumentId,
          ContextName: LocalStorageUtil.getItem("contextName") ?? "",
        };
        preworkDetailViewModel.push(objAcceptFile);
      });
      if (preworkDetailViewModel.length > 0) {
        const response = await AcceptPreworkDetails(preworkDetailViewModel);
        if (response === true) {
          handleFromSourceTabClick(1, "FROM SOURCE");
        }
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  // If parent record is checked then all child records should be checked
  const onSelectionChanged = useCallback(() => {
    if (!gridRef.current) return;
    const selectedNodes = gridRef.current.api.getSelectedNodes();

    // If any parent is selected, select all its children
    gridRef.current.api.forEachNode((node: any) => {
      if (node.detailNode?.detailGridInfo?.api) {
        const detailGrid = node.detailNode.detailGridInfo.api;
        if (selectedNodes.includes(node)) {
          // Parent is selected: select all children
          detailGrid.forEachNode((childNode: any) => {
            childNode.setSelected(true);
          });
        } else {
          // Parent is not selected: deselect all children
          detailGrid.forEachNode((childNode: any) => {
            childNode.setSelected(false);
          });
        }
      }
    });
  }, []);

  //#region Upload UI Screen
  const handleUploadClick = () => {
    navigate("/fileUpload");
  };
  //#endregion

  const refreshGridData = () => {
    if (tabType === 1) {
      handleFromSourceTabClick(1, "FROM SOURCE");
    } else if (tabType === 2) {
      if (inProgressTabType === 2) {
        handleStagingInProcessTabClick(2, "STAGING");
      } else if (inProgressTabType === 6) {
        handelToPreflightInProgressTabClick(6, "TO PREFLIGHT");
      } else if (inProgressTabType === 11) {
        handelFromPreflightInProgressTabClick(11, "FROM PREFLIGHT");
      } else if (inProgressTabType === 17) {
        handelToVISInProgressTabClick(17, "TO VIS");
      } else if (inProgressTabType === 18) {
        handelFromVISInProgressTabClick(18, "FROM VIS");
      }
    } else if (tabType === 3) {
      handleFinalTabClick(3, "FINAL");
    } else if (tabType === 0) {
      handleAllTabClick(0, "ALL");
    }
  };
  // Rendering UI
  return (
    <div>
      <NavigationBar title="Prework Detail" text="Prework Detail" />
      <Row style={{ margin: "10px" }}>
        <Col>
          <Box>
            <div className="rp-main-inner col-sm-12">
              <div className="queue-top row clearfix">
                {/* Buttons */}
                <div
                  className="col-sm-8"
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    marginTop: "20px",
                    width: "66%",
                  }}
                >
                  {isPagePermission(
                    "Allow Menu-FromMet",
                    "PreworkDetail",
                    168
                  ) && (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleFromSourceTabClick(1, "FROM SOURCE")}
                      style={{
                        backgroundColor:
                          activeButton === "FROM SOURCE" ? "#ddd" : "#4D7BA7",
                        color:
                          activeButton === "FROM SOURCE" ? "black" : "#ddd",

                        marginRight: "1em",
                        fontSize: "11px",
                        borderRadius: "4px",
                        border: "1px solid #858c94",
                        height: "25px",
                      }}
                    >
                      FROM SOURCE({fromSourceCount})
                    </Button>
                  )}
                  {
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleInProcessTabClick(2, "IN-PROGRESS")}
                      style={{
                        backgroundColor:
                          activeButton === "IN-PROGRESS" ? "#ddd" : "#4D7BA7",
                        color:
                          activeButton === "IN-PROGRESS" ? "black" : "#ddd",

                        marginRight: "1em",
                        fontSize: "11px",
                        borderRadius: "4px",
                        border: "1px solid #858c94",
                        height: "25px",
                      }}
                    >
                      IN-PROCESS({inProcessCount})
                    </Button>
                  }
                  {isPagePermission(
                    "Allow Menu-Final",
                    "PreworkDetail",
                    170
                  ) && (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleFinalTabClick(3, "FINAL")}
                      style={{
                        backgroundColor:
                          activeButton === "FINAL" ? "#ddd" : "#4D7BA7",
                        color: activeButton === "FINAL" ? "black" : "#ddd",

                        marginRight: "1em",
                        fontSize: "11px",
                        borderRadius: "4px",
                        border: "1px solid #858c94",
                        height: "25px",
                      }}
                    >
                      FINAL({finalCount})
                    </Button>
                  )}
                  {(isPagePermission("", "", 168) ||
                    isPagePermission("", "", 162) ||
                    isPagePermission("", "", 163) ||
                    isPagePermission("", "", 161) ||
                    isPagePermission("", "", 170)) &&
                    isPagePermission("", "", 171) && (
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => handleAllTabClick(0, "ALL")}
                        style={{
                          backgroundColor:
                            activeButton === "ALL" ? "#ddd" : "#4D7BA7",
                          color: activeButton === "ALL" ? "black" : "#ddd",

                          marginRight: "1em",
                          fontSize: "11px",
                          borderRadius: "4px",
                          border: "1px solid #858c94",
                          height: "25px",
                        }}
                      >
                        ALL({allCount})
                      </Button>
                    )}
                </div>

                <div
                  className="col-sm-4"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    borderRadius: "4px",
                    overflow: "visible",
                    width: "100%",
                    minWidth: "300px",
                    height: "2.20em",
                    fontSize: "11px",
                    marginTop: "-2.2em",
                    marginLeft: "auto",
                    flexWrap: "nowrap",
                    gap: "2px",
                  }}
                >
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchContent}
                    onChange={handleSearchChange}
                    onKeyDown={handleSearchKeyPress}
                    className="searchInput"
                    style={{
                      width: "150px",
                      minWidth: "120px",
                      height: "2.30em",
                      padding: "0.5em",
                      flexShrink: 0,
                    }}
                  />
                  <Tooltip title="Please click to search">
                    <button
                      onClick={handleSearchSubmit}
                      className="searchButton"
                      style={{ flexShrink: 0 }}
                    >
                      <SearchIcon style={{ color: "#006ab6" }} />
                    </button>
                  </Tooltip>
                  {showIconButton && (
                    <Tooltip title="Clear to reset search result">
                      <ClearIcon
                        onClick={handelSearchContentClear}
                        style={{
                          height: "1em",
                          width: "1em",
                          color: "var(--text-color)",
                          cursor: "pointer",
                          flexShrink: 0,
                        }}
                      />
                    </Tooltip>
                  )}
                  {isPagePermission("Allow Upload", "PreworkDetail", 160) && (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleUploadClick}
                      style={{
                        backgroundColor: "var(--button-background-color)",
                        color: "var(--button-color)",
                        textTransform: "none",
                        fontSize: "11px",
                        paddingTop: "2px",
                        paddingBottom: "5px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        marginBottom: "5px",
                        whiteSpace: "nowrap",
                        borderRadius: "4px",
                        minWidth: "70px",
                        height: "25px",
                        flexShrink: 0,
                      }}
                    >
                      Upload
                    </Button>
                  )}
                </div>

                <div
                  className="col-sm-12"
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    marginTop: "20px",
                  }}
                >
                  {/* Dates, Apply and Reset buttons */}
                  <div
                    className="col-sm-8"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <InputLabel
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        color: "var(--text-color)",
                        display: "inline-block !important",
                        marginBottom: "5px !important",
                        fontWeight: 600,
                        fontSize: "11px",
                      }}
                    >
                      From Date: *
                    </InputLabel>
                    <Form.Control
                      type="date"
                      placeholder="From Date"
                      title="From Date"
                      name="fromdate"
                      max={new Date().toISOString().split("T")[0]}
                      value={
                        startDate ? startDate.toISOString().split("T")[0] : ""
                      }
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        handleDateChange(
                          e.target.value ? new Date(e.target.value) : null,
                          "startDate"
                        )
                      }
                      style={{
                        padding: ".3em",
                        width: "15%",
                        fontSize: "12px",
                        borderRadius: "0",
                        border: "1px solid #ccc",
                        borderColor: "black",
                        marginTop: ".1em",
                      }}
                    />
                    <InputLabel
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        color: "var(--text-color)",
                        display: "inline-block !important",
                        marginBottom: "5px !important",
                        fontWeight: 600,
                        fontSize: "11px",
                      }}
                    >
                      To Date: *
                    </InputLabel>
                    <Form.Control
                      type="date"
                      placeholder="To Date"
                      name="todate"
                      value={endDate ? endDate.toISOString().split("T")[0] : ""}
                      max={new Date().toISOString().split("T")[0]}
                      onChange={(e) => setEndDate(new Date(e.target.value))}
                      style={{
                        padding: ".3em",
                        width: "15%",
                        fontSize: "12px",
                        borderRadius: "0",
                        border: "1px solid #ccc",
                        borderColor: "black",
                        marginTop: ".1em",
                      }}
                    />
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleApplyButton}
                      className="button"
                      style={{
                        marginBottom: ".5em",
                      }}
                    >
                      Apply
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleReset}
                      className="button"
                      style={{
                        marginBottom: ".5em",
                      }}
                    >
                      Reset
                    </Button>
                  </div>

                  {/* Grid Preferences and export to excel */}
                  <div
                    className="col-sm-4"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      content: "flex-end",
                      justifyContent: "flex-end",
                      width: "32%",
                    }}
                  >
                    {validateAccept !== null && (
                      <Typography color="error" style={{ marginTop: "10px" }}>
                        {validateAccept}
                      </Typography>
                    )}
                    {tabType === 1 &&
                    isPagePermission("Allow Accept", "PreworkDetail", 152) ? (
                      <Button
                        variant="contained"
                        size="small"
                        onClick={handleAcceptClick}
                        className="button"
                      >
                        Accept
                      </Button>
                    ) : null}
                    {gridRecordExist && (
                      <>
                        {isPagePermission(
                          "Allow Export To Excel",
                          "PreworkDetail",
                          153
                        ) && (
                          <Tooltip title="Click to export the grid content in excel">
                            <button
                              onClick={handleExport}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  e.preventDefault();
                                  handleExport();
                                }
                              }}
                              style={{
                                cursor: "pointer",
                                background: "none",
                                border: "none",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                              }}
                              aria-label="Export to Excel"
                            >
                              <img
                                src={ExcelIcon}
                                alt="Doc-Distro"
                                style={{ width: "30px" }}
                              />
                            </button>
                          </Tooltip>
                        )}
                      </>
                    )}
                  </div>
                </div>
                {validationMessage && (
                  <div
                    className="col-sm-12"
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography color="error" style={{ marginTop: "10px" }}>
                      {validationMessage}
                    </Typography>
                  </div>
                )}

                {/* Tab 2 Buttons */}
                {tabType === 2 &&
                  (inProgressTabType === 2 ||
                    inProgressTabType === 6 ||
                    inProgressTabType === 11 ||
                    inProgressTabType === 17 ||
                    inProgressTabType === 18) && (
                    <div
                      className="col-sm-12"
                      style={{
                        display: "flex",
                        gap: "5px",
                        alignItems: "center",
                        marginTop: "20px",
                      }}
                    >
                      {isPagePermission("", "", 161) && (
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() =>
                            handleStagingInProcessTabClick(2, "STAGING")
                          }
                          style={{
                            backgroundColor:
                              activeButtonInProgress === "STAGING"
                                ? "#ddd"
                                : "#4D7BA7",
                            color:
                              activeButtonInProgress === "STAGING"
                                ? "black"
                                : "#ddd",
                            marginRight: "1em",
                            fontSize: "11px",
                            borderRadius: "4px",
                            border: "1px solid #858c94",
                            height: "25px",
                          }}
                        >
                          STAGING
                        </Button>
                      )}
                      {isPagePermission("", "", 162) && (
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() =>
                            handelToPreflightInProgressTabClick(
                              6,
                              "TO PREFLIGHT"
                            )
                          }
                          style={{
                            backgroundColor:
                              activeButtonInProgress === "TO PREFLIGHT"
                                ? "#ddd"
                                : "#4D7BA7",
                            color:
                              activeButtonInProgress === "TO PREFLIGHT"
                                ? "black"
                                : "#ddd",
                            marginRight: "1em",
                            fontSize: "11px",
                            borderRadius: "4px",
                            border: "1px solid #858c94",
                            height: "25px",
                          }}
                        >
                          TO PREFLIGHT
                        </Button>
                      )}
                      {isPagePermission("", "", 163) && (
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() =>
                            handelFromPreflightInProgressTabClick(
                              11,
                              "FROM PREFLIGHT"
                            )
                          }
                          style={{
                            backgroundColor:
                              activeButtonInProgress === "FROM PREFLIGHT"
                                ? "#ddd"
                                : "#4D7BA7",
                            color:
                              activeButtonInProgress === "FROM PREFLIGHT"
                                ? "black"
                                : "#ddd",
                            marginRight: "1em",
                            fontSize: "11px",
                            borderRadius: "4px",
                            border: "1px solid #858c94",
                            height: "25px",
                          }}
                        >
                          FROM PREFLIGHT
                        </Button>
                      )}
                      {isPagePermission("", "", 1327) && (
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() =>
                            handelToVISInProgressTabClick(17, "TO VIS")
                          }
                          style={{
                            backgroundColor:
                              activeButtonInProgress === "TO VIS"
                                ? "#ddd"
                                : "#4D7BA7",
                            color:
                              activeButtonInProgress === "TO VIS"
                                ? "black"
                                : "#ddd",

                            marginRight: "1em",
                            fontSize: "11px",
                            borderRadius: "4px",
                            border: "1px solid #858c94",
                            height: "25px",
                          }}
                        >
                          TO VIS
                        </Button>
                      )}
                      {isPagePermission("", "", 1326) && (
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() =>
                            handelFromVISInProgressTabClick(18, "FROM VIS")
                          }
                          style={{
                            backgroundColor:
                              activeButtonInProgress === "FROM VIS"
                                ? "#ddd"
                                : "#4D7BA7",
                            color:
                              activeButtonInProgress === "FROM VIS"
                                ? "black"
                                : "#ddd",

                            marginRight: "1em",
                            fontSize: "11px",
                            borderRadius: "4px",
                            border: "1px solid #858c94",
                            height: "25px",
                          }}
                        >
                          FROM VIS
                        </Button>
                      )}
                    </div>
                  )}
                {/* Indication bar */}
                {(tabType === 3 ||
                  inProgressTabType === 6 ||
                  inProgressTabType === 11 ||
                  inProgressTabType === 18 ||
                  inProgressTabType === 17) && (
                  <div
                    className="retrun_status_notebar bubbles-holder1 col-sm-11 display-note"
                    style={{ width: "97.5%", marginTop: "10px" }}
                  >
                    {/* Topreflight */}
                    {inProgressTabType === 6 && (
                      <div className="bubbles-holder1 display-note">
                        <span className="yellow_circle">N</span>
                        <strong>
                          {" "}
                          : <small>MPF Inprogress</small>
                        </strong>
                        <span className="green_circle">Y</span>
                        <strong>
                          {" "}
                          : <small>Export to MPF</small>
                        </strong>
                        <span className="red_circle">F</span>
                        <strong>
                          {" "}
                          : <small>Fail</small>
                        </strong>
                      </div>
                    )}
                    {/* Final */}
                    {tabType === 3 && (
                      <div className="bubbles-holder1 display-note">
                        <span className="yellow_circle">N</span>
                        <strong>
                          {" "}
                          : <small>Final Inprogress</small>
                        </strong>
                        <span className="yellow_circle">N</span>
                        <strong>
                          {" "}
                          : <small>Trigger Prod WF Inprogress</small>
                        </strong>
                        <span className="green_circle">Y</span>
                        <strong>
                          {" "}
                          : <small>Move To Final Success</small>
                        </strong>
                        <span className="red_circle">F</span>
                        <strong>
                          {" "}
                          : <small>Fail</small>
                        </strong>
                      </div>
                    )}
                    {/* reprocess Formpreflight */}
                    {inProgressTabType === 11 && (
                      <div className="bubbles-holder1 display-note">
                        <span className="green_circle">Y</span>
                        <strong>
                          {" "}
                          : <small>From Preflight Success</small>
                        </strong>
                        <span className="red_circle">F</span>
                        <strong>
                          {" "}
                          : <small>Fail</small>
                        </strong>
                      </div>
                    )}
                    {/* trigger Proof wf */}
                    {inProgressTabType === 17 && (
                      <div className="bubbles-holder1 display-note">
                        <span className="yellow_circle">N</span>
                        <strong>
                          {" "}
                          : <small>Trigger Proof WF Inprogress</small>
                        </strong>
                        <span className="green_circle">Y</span>
                        <strong>
                          {" "}
                          : <small>Trigger Proof WF Success</small>
                        </strong>
                        <span className="red_circle">F</span>
                        <strong>
                          {" "}
                          : <small>Fail</small>
                        </strong>
                      </div>
                    )}
                    {/* from vis Reprocess */}
                    {inProgressTabType === 18 && (
                      <div className="bubbles-holder1 display-note">
                        <span className="green_circle">Y</span>
                        <strong>
                          {" "}
                          : <small>From VIS Success</small>
                        </strong>
                        <span className="red_circle">F</span>
                        <strong>
                          {" "}
                          : <small>Fail</small>
                        </strong>
                      </div>
                    )}
                  </div>
                )}
                {/* AgGrid */}
                <div className="queue-table-view clearfix">
                  <div
                    className="ag-theme-quartz-dark"
                    style={{
                      height: "60vh",
                      width: "100%",
                      marginTop: "1em",
                    }}
                  >
                    <AgGridReact
                      columnDefs={columnDefs}
                      rowData={rowData}
                      ref={gridRef}
                      masterDetail={true}
                      detailCellRendererParams={detailCellRendererParams}
                      pagination={true}
                      paginationPageSize={defaultPageSize}
                      paginationPageSizeSelector={pageSizeSelector}
                      gridOptions={{
                        rowSelection: {
                          mode: "multiRow",
                          checkboxes: true,
                          headerCheckbox: true,
                          enableClickSelection: false,
                        },
                      }}
                      headerHeight={30}
                      rowGroupPanelShow="always"
                      pivotPanelShow="always"
                      detailRowHeight={250}
                      onSelectionChanged={onSelectionChanged}
                      loading={!rowData || showLoader}
                      loadingOverlayComponent={CustomLoadingOverlay}
                      isRowMaster={(data: any) =>
                        data.ChildList && data.ChildList.length > 0
                      }
                      groupDefaultExpanded={1}
                      overlayNoRowsTemplate={
                        '<span class="ag-overlay-loading-center">No rows to show</span>'
                      }
                    />
                  </div>
                </div>
                {/* Info Drawer */}
                <div>
                  <InfoDrawer
                    isOpen={drawerOpen}
                    onClose={toggleDrawer(false)}
                    title="Document Info"
                    tabLabels={["Information", "Version History"]}
                    selectedDocument={selectedDocument}
                  />
                </div>
                <div>
                  {/* Notes popup */}
                  {notesOpen && (
                    <Notes
                      isOpen={notesOpen}
                      onClose={closeNotesPopup}
                      title="View Instruction"
                      selectedData={notesData}
                      gridType={type}
                      screen="preworkdetail"
                    />
                  )}
                </div>

                {/* Upload Files Dialog */}
                {uploadFilesOpen && (
                  <FileUploads
                    isOpen={uploadFilesOpen}
                    onClose={closeUploadFiles}
                    title="Upload Files"
                    selectedData={uploadFilesData}
                    screenType="PreworkDetails"
                  />
                )}

                {/* Add Notes Dialog */}
                {addNotesOpen && (
                  <AddNotes
                    isOpen={addNotesOpen}
                    onClose={closeAddNotes}
                    title="Add Notes"
                    selectedData={addNotesData}
                    screenType="PreworkDetails"
                    tabValue={inProgressTabType}
                  />
                )}

                {/* Rename popup */}
                {renamePopupOpen && (
                  <RenamePopup
                    isOpen={renamePopupOpen}
                    onClose={closeRenamePopup}
                    title="Rename File"
                    selectedData={renameData}
                    tabValue={inProgressTabType}
                  />
                )}

                {/* Reject popup */}
                {rejectPopupOpen && (
                  <RejectFile
                    isOpen={rejectPopupOpen}
                    onClose={closeRejectPopup}
                    title="Reject File"
                    selectedData={rejectData}
                    tabValue={inProgressTabType}
                  />
                )}

                {/* Delete Confirmation dialogbox */}
                {deleteConfirmationDialogOpen && (
                  <ConfirmationAlert
                    isOpen={deleteConfirmationDialogOpen}
                    onClose={closeConfirmationDialogbox}
                    title="Delete Confirmation"
                    selectedData={deleteDocumentData}
                    isArf={false}
                    screen="PreworkDetails"
                  />
                )}

                {/* Move to Preflight Dialog */}
                {moveToPreflightOpen && (
                  <MoveToPreflightPopup
                    isOpen={moveToPreflightOpen}
                    onClose={closeMoveToPreflight}
                    title="Move To Preflight"
                    selectedData={moveToPreflightData}
                    documentStatus={documentStatusValue}
                    tabValue={inProgressTabType}
                  />
                )}

                {/* Move to Final Folder Dialog */}
                {moveToFinalFolderOpen && (
                  <MoveToFinal
                    isOpen={moveToFinalFolderOpen}
                    onClose={closeMoveToFinalFolder}
                    title={moveToFinalPopupTitle}
                    selectedData={moveToFinalFolderData}
                    contextMenuType={contextMenuType}
                    tabValue={inProgressTabType}
                  />
                )}

                {/* Reprocess Send to Preflight Dialog */}
                {reprocessSendToPreflightOpen && (
                  <ReprocessSendToPreflight
                    isOpen={reprocessSendToPreflightOpen}
                    onClose={closeReprocessSendToPreflight}
                    title="Reprocess"
                    selectedData={reprocessSendToPreflightData}
                    tabValue={inProgressTabType}
                  />
                )}

                {/* Docview Popup */}
                {docViewOpen && (
                  <DocviewPopup
                    isOpen={docViewOpen}
                    onClose={closeDocviewPopup}
                    title="File View"
                    selectedData={docViewData}
                  />
                )}
              </div>
            </div>
          </Box>
        </Col>
      </Row>
    </div>
  );
};

export default PreworkDetail;
